import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  es: {
    translation: {
      nav: {
        home: "Inicio",
        howItWorks: "Cómo Funciona",
        pricing: "Precios",
        login: "Iniciar Sesión",
        register: "Registrarse",
        dashboard: "Mi Panel",
        admin: "Admin",
        help: "Ayuda",
        logout: "Cerrar Sesión"
      },
      help: {
        title: "Centro de ayuda",
        subtitle: "Resuelve dudas con el asistente o contáctanos directamente.",
        tabs: { chatbot: "Asistente IA", faqs: "Preguntas frecuentes", tour: "Tour guiado", contact: "Contacto" },
        floating: { tooltip: "Ayuda" },
        tour: {
          title: "Tour guiado de la app",
          description: "Un recorrido visual de 60 segundos por todas las funciones principales.",
          start: "Empezar tour",
          restart: "Repetir tour",
          resetBtn: "Marcar como no visto",
          reset: "Tour reiniciado. Se mostrará la próxima vez que entres.",
          back: "Atrás", close: "Cerrar", last: "Finalizar", next: "Siguiente", skip: "Saltar",
          welcomeTitle: "¡Bienvenido a A Gift of Memories!",
          welcome: "Te guiaremos por la app en 60 segundos. Usa las flechas para avanzar.",
          dashboard: "Aquí es tu panel principal. Verás todos tus libros activos y su estado.",
          createBook: "Pulsa aquí para crear un nuevo libro. Te guiaremos en 4 pasos.",
          booksList: "Todos tus libros aparecen aquí. Haz clic en uno para gestionarlo.",
          invoices: "En esta pestaña encuentras tus facturas y puedes descargarlas en PDF.",
          helpBtn: "¿Tienes dudas? Usa este botón flotante para abrir la ayuda en cualquier momento.",
          endTitle: "¡Listo!",
          end: "Ya conoces la app. Si necesitas más ayuda, usa el chatbot o las FAQs."
        },
        chatbot: { title: "Asistente Memories", subtitle: "Pregúntame lo que quieras sobre la app", placeholder: "Escribe tu pregunta...", voiceOn: "Activar voz", voiceOff: "Voz activada", listen: "Escuchar", stopListening: "Detener" },
        chatError: "No pude responder, inténtalo de nuevo.",
        faqs: {
          searchPlaceholder: "Buscar en FAQs...",
          noResults: "No hay resultados para tu búsqueda",
          catAll: "Todas", catGeneral: "General", catStart: "Primeros pasos", catContributors: "Colaboradores", catProcess: "Proceso", catAI: "Inteligencia Artificial", catPricing: "Precios y pago", catContent: "Contenido del libro", catPrivacy: "Privacidad", catShipping: "Envíos", catSupport: "Soporte"
        },
        contact: {
          categoryLabel: "Tipo de consulta",
          catQuestion: "Duda", catSuggestion: "Sugerencia", catIncident: "Incidencia", catComplaint: "Reclamación",
          name: "Nombre", email: "Email", subject: "Asunto", message: "Mensaje",
          privacy: "Tus datos se usan solo para responder a tu consulta.",
          submit: "Enviar mensaje",
          sent: "¡Mensaje enviado! Te responderemos pronto.",
          error: "Error al enviar. Inténtalo de nuevo.",
          fillAll: "Por favor rellena todos los campos",
          thanksTitle: "¡Mensaje recibido!",
          thanksDesc: "Te hemos enviado un email de confirmación. Responderemos en menos de 24 horas laborables.",
          sendAnother: "Enviar otro mensaje"
        }
      },
      hero: {
        title: "Crea un libro único lleno de recuerdos",
        subtitle: "Recopila historias de familiares y amigos, y nuestra IA las convertirá en un libro personalizado y hermoso",
        cta: "Crear Mi Libro"
      },
      profiles: {
        title: "Para todas las edades",
        subtitle: "Libros personalizados adaptados a cada etapa de la vida",
        child: "Infantil",
        childDesc: "Historias mágicas para los más pequeños",
        teen: "Adolescente",
        teenDesc: "Recuerdos divertidos y significativos",
        adult: "Adulto",
        adultDesc: "Reflexiones profundas y emotivas",
        senior: "Tercera Edad",
        seniorDesc: "Celebrando toda una vida",
        infantil: "Infantil",
        adolescente: "Adolescente",
        adulto: "Adulto",
        tercera_edad: "Tercera Edad",
        terceraedad: "Tercera Edad"
      },
      howItWorks: {
        title: "¿Cómo funciona?",
        subtitle: "En 4 sencillos pasos tendrás un regalo inolvidable",
        step1: {
          title: "Crea tu proyecto",
          desc: "Elige el perfil del destinatario y la ocasión especial"
        },
        step2: {
          title: "Invita colaboradores",
          desc: "Familiares y amigos comparten sus recuerdos"
        },
        step3: {
          title: "Creamos una pieza única",
          desc: "Te ayudamos a redactar el libro con nuestros agentes de IA"
        },
        step4: {
          title: "Recibe tu libro",
          desc: "Impreso con calidad premium y enviado a tu puerta"
        }
      },
      pricing: {
        title: "Precio transparente",
        subtitle: "Sin sorpresas, sin costes ocultos",
        basePrice: "60€",
        basePriceLabel: "primer ejemplar",
        extraPrice: "+20€",
        extraPriceLabel: "por ejemplar extra",
        shippingCollaborators: "+5€ por direccion (si colaboradores compran)",
        deliveryTime: "Entrega en 15-20 dias",
        features: {
          pages: "200 paginas (blanco/negro y color)",
          format: "Tapa blanda, tamano A5",
          contributors: "Colaboradores ilimitados",
          ai: "Generacion con IA personalizada",
          cover: "Portada, lomo y contraportada personalizados",
          reviews: "Resenas humoristicas generadas por IA",
          extras: "Ejemplares extra para familia y amigos"
        },
        collaboratorsNote: "Los colaboradores tambien pueden comprar su ejemplar (+20€ + 5€ envio)",
        cta: "Empezar Ahora"
      },
      footer: {
        tagline: "Creando recuerdos que perduran",
        rights: "Todos los derechos reservados"
      },
      auth: {
        login: "Iniciar Sesión",
        register: "Crear Cuenta",
        email: "Correo electrónico",
        password: "Contraseña",
        name: "Nombre completo",
        firstName: "Nombre",
        lastName: "Apellidos",
        phone: "Teléfono",
        forgotPassword: "¿Olvidaste tu contraseña?",
        rememberMe: "Recordarme",
        noAccount: "¿No tienes cuenta?",
        hasAccount: "¿Ya tienes cuenta?",
        orContinueWith: "O continúa con",
        google: "Continuar con Google",
        resetPassword: "Recuperar contraseña",
        resetDescription: "Introduce tu email y te enviaremos un enlace para restablecer tu contraseña",
        sendResetLink: "Enviar enlace",
        resetSent: "Enlace enviado",
        resetSentDesc: "Si existe una cuenta con este email, recibirás un enlace para restablecer tu contraseña",
        resetLinkPreview: "Enlace de recuperación:",
        clickToReset: "Haz clic aquí para restablecer tu contraseña",
        backToLogin: "Volver al inicio de sesión",
        newPassword: "Nueva contraseña",
        confirmPassword: "Confirmar contraseña",
        changePassword: "Cambiar contraseña",
        passwordMismatch: "Las contraseñas no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        passwordResetSuccess: "Contraseña cambiada con éxito. Inicia sesión con tu nueva contraseña",
        resetError: "Error al restablecer la contraseña",
        invalidToken: "Enlace no válido",
        invalidTokenDesc: "Este enlace ha expirado o no es válido. Solicita uno nuevo.",
        requestNewLink: "Solicitar nuevo enlace"
      },
      dashboard: {
        welcome: "Bienvenido",
        myBooks: "Mis Libros",
        createNew: "Crear Nuevo Libro",
        noBooks: "Aún no tienes libros",
        noBooksDesc: "Crea tu primer libro personalizado",
        orders: "Mis Pedidos",
        noOrders: "Sin pedidos aún",
        noOrdersDesc: "Cuando pidas la impresión de un libro, aparecerá aquí",
        book: "libro",
        books: "libros",
        filterAll: "Todos",
        filterActive: "Activos",
        filterClosed: "Cerrados",
        noFilteredBooks: "No hay libros con este filtro",
        colTitle: "Título",
        colRecipient: "Destinatario",
        colStatus: "Estado",
        colDate: "Fecha",
        deleteBook: "Eliminar libro",
        confirmDeleteBook: "¿Quiere realmente borrar este libro",
        deleteBookWarning: "Esta acción eliminará permanentemente:",
        deleteBookData: "El libro y todo su contenido generado",
        deleteBookContributors: "Todos los colaboradores asignados",
        deleteBookContributions: "Todas las contribuciones recibidas",
        bookDeleted: "Libro eliminado correctamente",
        myTasks: "Mis Tareas Pendientes",
        delayed: "Fuera de plazo",
        remaining: "restantes",
        onTrack: "En plazo",
        pendingTasks: "tareas pendientes",
        noTasksDesc: "No tienes tareas pendientes",
        changePhase: "Cambiar fase",
        selectPhase: "Seleccionar fase",
        statusChanged: "Estado cambiado correctamente"
      },
      book: {
        create: "Crear Libro",
        title: "Título del libro",
        titlePlaceholder: "Ejem: El libro de María",
        profile: "Perfil del destinatario",
        recipientName: "Nombre del destinatario",
        recipientAge: "Edad (opcional)",
        relationship: "Tu relación con el destinatario",
        occasion: "Ocasión especial",
        language: "Idioma del libro",
        coverStyle: "Estilo de portada",
        contributors: "Colaboradores",
        addContributor: "Añadir colaborador",
        contributions: "Contribuciones recibidas",
        generate: "Generar Libro",
        preview: "Vista Previa",
        order: "Pedir Impresión",
        status: {
          collecting: "Recopilando",
          generating: "Generando",
          ready: "Listo",
          ordered: "Pedido",
          shipped: "Enviado"
        }
      },
      contributor: {
        name: "Nombre",
        email: "Correo electrónico",
        relationship: "Relación",
        invite: "Enviar invitación",
        copyLink: "Copiar enlace",
        linkCopied: "¡Enlace copiado!",
        pending: "Pendiente",
        contributed: "Contribuido"
      },
      contribution: {
        title: "Comparte tu recuerdo",
        welcome: "Bienvenido",
        forBook: "Estás contribuyendo al libro de",
        memoryTitle: "Título del recuerdo",
        memoryTitlePlaceholder: "Ejem: Aquel verano en la playa",
        memoryContent: "Tu historia o recuerdo",
        memoryContentPlaceholder: "Cuenta tu historia con todo detalle...",
        memoryDate: "Fecha aproximada (opcional)",
        emotion: "¿Cómo describirías este recuerdo?",
        emotions: {
          feliz: "Feliz",
          divertido: "Divertido",
          emotivo: "Emotivo",
          inspirador: "Inspirador"
        },
        submit: "Enviar Recuerdo",
        thanks: "¡Gracias por tu contribución!",
        alreadyContributed: "Ya has enviado tu contribución"
      },
      order: {
        checkout: "Finalizar Pedido",
        summary: "Resumen del pedido",
        quantity: "Cantidad",
        unitPrice: "Precio unitario",
        shipping: "Envío",
        total: "Total",
        shippingInfo: "Información de envío",
        fullName: "Nombre completo",
        address: "Dirección",
        city: "Ciudad",
        postalCode: "Código postal",
        country: "País",
        phone: "Teléfono",
        payNow: "Pagar Ahora",
        success: "¡Pago completado!",
        successDesc: "Tu pedido está en proceso",
        tracking: "Seguimiento",
        status: {
          pending: "Pendiente de pago",
          paid: "Pagado",
          processing: "En proceso",
          printing: "Imprimiendo",
          shipped: "Enviado",
          delivered: "Entregado"
        }
      },
      admin: {
        title: "Panel de Administración",
        subtitle: "Gestiona usuarios y supervisa la plataforma",
        refresh: "Actualizar",
        totalUsers: "Usuarios totales",
        clients: "Clientes",
        monthlyRevenue: "Ingresos (mes)",
        employees: "Empleados",
        booksCreated: "Libros creados",
        totalOrders: "Pedidos totales",
        newRecent: "Nuevos (7 días)",
        clientManagement: "Gestión de Clientes",
        employeeManagement: "Gestión de Empleados",
        registeredUsers: "usuarios registrados",
        registeredClients: "clientes registrados",
        registeredEmployees: "empleados registrados",
        searchPlaceholder: "Buscar por nombre, email o teléfono...",
        user: "Usuario",
        contact: "Contacto",
        books: "Libros",
        orders: "Pedidos",
        role: "Rol",
        registered: "Registro",
        actions: "Acciones",
        viewDetails: "Ver detalles",
        makeAdmin: "Hacer admin",
        removeAdmin: "Quitar admin",
        deleteUser: "Eliminar",
        noUsersFound: "No se encontraron usuarios",
        userDetails: "Detalles del Usuario",
        client: "Cliente",
        employee: "Empleado",
        noBooks: "Sin libros creados",
        noOrders: "Sin pedidos",
        noEmployees: "Sin empleados registrados",
        noEmployeesDesc: "Convierte usuarios clientes en empleados desde la pestaña de Clientes",
        convertToEmployee: "Convertir en empleado",
        convertToClient: "Convertir en cliente",
        convertedToEmployee: "Usuario convertido a empleado",
        convertedToClient: "Usuario convertido a cliente",
        managePermissions: "Gestionar permisos",
        permissionsSaved: "Permisos actualizados",
        perm_manage_users: "Gestión de usuarios",
        perm_manage_books: "Gestión de libros",
        perm_manage_orders: "Gestión de pedidos",
        perm_manage_contributions: "Gestión de contribuciones",
        perm_view_stats: "Ver estadísticas",
        permDesc_manage_users: "Puede ver y gestionar cuentas de usuario",
        permDesc_manage_books: "Puede ver y gestionar todos los libros",
        permDesc_manage_orders: "Puede ver y gestionar pedidos",
        permDesc_manage_contributions: "Puede ver y gestionar contribuciones",
        permDesc_view_stats: "Puede ver las estadísticas de la plataforma",
        confirmDelete: "Eliminar Usuario",
        confirmDeleteDesc: "¿Estás seguro de que quieres eliminar a",
        deleteWarning: "Esta acción eliminará permanentemente:",
        deleteAccount: "Cuenta del usuario",
        deleteAllBooks: "Todos sus libros",
        deleteAllOrders: "Todos sus pedidos",
        deleteContributions: "Todas las contribuciones asociadas",
        cancel: "Cancelar",
        userPromoted: "Usuario promovido a admin",
        adminRemoved: "Permisos de admin removidos",
        userDeleted: "Usuario eliminado",
        bookDeleted: "Proyecto eliminado",
        editUser: "Editar usuario",
        createUser: "Crear usuario",
        createClient: "Nuevo cliente",
        createEmployee: "Nuevo empleado",
        userCreated: "Usuario creado con éxito",
        userUpdated: "Usuario actualizado con éxito",
        fillRequired: "Completa los campos obligatorios (nombre, email, contraseña)",
        leaveBlankKeep: "dejar vacío para mantener",
        deleteBook: "Eliminar proyecto",
        confirmDeleteBookDesc: "¿Quiere realmente borrar este proyecto",
        deleteBookWarning: "Esta acción eliminará permanentemente:",
        deleteBookData: "El proyecto y todo su contenido",
        deleteBookContributors: "Todos los colaboradores asignados",
        deleteBookContributions: "Todas las contribuciones recibidas",
        deleteBookOrders: "Los pedidos asociados",
        accessDenied: "Acceso denegado",
        noAdminPermissions: "No tienes permisos de administrador",
        noName: "Sin nombre",
        bookStatusManagement: "Gestión de Estados de Libros",
        totalBooks: "libros en total",
        searchBooks: "Buscar por título, propietario o email...",
        owner: "Propietario",
        noBooksFound: "No se encontraron libros",
        statusUpdated: "Estado actualizado correctamente",
        bookStatus: {
          alta: "Alta",
          recopilando: "Recopilando",
          generando: "Generando",
          en_revision: "En revisión",
          revisado: "Revisado",
          listo_impresion: "Listo impresión",
          enviado_imprenta: "Enviado imprenta",
          recibido_imprenta: "Recibido de imprenta",
          recibido: "Recibido",
          revision_imprenta: "Revisión imprenta",
          envio_prueba: "Envío prueba",
          preparacion_imprenta: "Preparación para imprenta",
          envio_imprenta: "Envío a imprenta",
          envio_cliente: "Envío al cliente",
          recibido_cliente: "Recibido cliente",
          generado: "Generado",
          ok_prueba: "Ok prueba",
          regenerando: "Regenerando",
          collecting: "Recopilando",
          generating: "Generando",
          review: "En revisión",
          reviewed: "Revisado",
          ready_print: "Listo impresión",
          sent_print: "Enviado impresión",
          sent_client: "Enviado cliente",
          delivered: "Entregado",
          ready: "Listo",
          ordered: "Pedido"
        },
        tracking: "Seguimiento",
        trackingOnTrack: "En plazo",
        trackingDelayed: "Fuera de plazo",
        trackingCompleted: "Completado",
        phaseConfig: "Configurar tiempos",
        phaseConfigDesc: "Define los tiempos estándar (en días) para cada fase de los libros",
        phaseConfigSaved: "Configuración de tiempos guardada",
        phaseConfigApplied: "Tiempos aplicados a {{count}} libros",
        applyToAllBooks: "Aplicar a todos los libros",
        phaseDetail: "Detalle de fases",
        phaseTimeUpdated: "Tiempo de fase actualizado",
        currentPhase: "Fase actual",
        viewPhases: "Ver fases",
        days: "días",
        defaultPhases: "Fases asignadas por defecto",
        assignmentSaved: "Asignación guardada",
        unassigned: "Sin asignar",
        responsible: "Responsable",
        phase: "Fase",
        timing: "Tiempo",
        dueDate: "Vencimiento",
        pendingTasks: "Tareas Pendientes",
        taskAssignPhases: "Asignar responsables",
        assignResponsibles: "Asignar",
        taskCompleted: "Tarea completada",
        createdBy: "Creado por"
      },
      createBook: {
        whoIsBookFor: "¿Para quién es el libro?",
        selectProfile: "Selecciona el perfil del destinatario",
        bookDetails: "Detalles del libro",
        tellUsMore: "Cuéntanos más sobre el destinatario",
        customization: "Personalización",
        chooseLanguageStyle: "Elige el idioma y estilo del libro",
        step: "Paso",
        of: "de",
        summary: "Resumen",
        bookCreated: "¡Libro creado con éxito!",
        errorCreating: "Error al crear el libro",
        otherOccasion: "Especifica la ocasión",
        otherOccasionPlaceholder: "Ejem: Homenaje, Bautizo, Comunión..."
      },
      occasions: {
        cumpleanos: "Cumpleaños",
        navidad: "Navidad",
        jubilacion: "Jubilación",
        aniversario: "Aniversario",
        graduacion: "Graduación",
        dia_madre: "Día de la Madre",
        dia_padre: "Día del Padre",
        otro: "Otra ocasión"
      },
      coverStyles: {
        classic: "Clásico",
        classicDesc: "Elegante y atemporal",
        modern: "Moderno",
        modernDesc: "Minimalista y fresco",
        playful: "Divertido",
        playfulDesc: "Colorido y alegre",
        vintage: "Vintage",
        vintageDesc: "Nostálgico y cálido"
      },
      bookDetail: {
        backToDashboard: "Volver al panel",
        for: "Para",
        collaborators: "Colaboradores",
        contributions: "Contribuciones",
        language: "Idioma",
        created: "Creado",
        collaboratorList: "Lista de colaboradores",
        noCollaborators: "Aún no hay colaboradores",
        noCollaboratorsDesc: "Invita a familiares y amigos a compartir sus recuerdos",
        noContributions: "Aún no hay contribuciones",
        noContributionsDesc: "Las contribuciones aparecerán aquí cuando los colaboradores envíen sus recuerdos",
        addCollaboratorGuest: "Añadir colaborador / invitado",
        tableNumber: "Nº de Mesa",
        selectTable: "Selecciona mesa...",
        dietType: "Tipo de Dieta",
        selectDiet: "Selecciona dieta...",
        openLink: "Abrir enlace",
        deleteCollaborator: "Eliminar colaborador",
        confirmDeleteDesc: "¿Estás seguro de que quieres eliminar a",
        contributorAlreadyContributed: "Este colaborador ya ha enviado su contribución. Si lo eliminas, también se borrará su aportación.",
        completeRequired: "Completa los campos obligatorios",
        collaboratorAdded: "Colaborador añadido",
        collaboratorDeleted: "Colaborador eliminado",
        needContribution: "Necesitas al menos una contribución para generar el libro",
        generating: "Generando...",
        bookGenerated: "¡Libro generado con éxito!",
        bookPreview: "Vista previa del libro",
        previewDesc: "Contenido generado por IA basado en las contribuciones",
        by: "Por",
        confirmCollection: "Confirmar fin de recopilación",
        confirmCollectionDesc: "¿Confirmas que has recibido suficientes contribuciones? El libro pasará a la fase de generación.",
        confirmCollectionBtn: "Confirmar y generar libro",
        collectionConfirmed: "Recopilación confirmada. El libro pasa a generación.",
        extendDeadline: "Ampliar plazo",
        extendDeadlineDesc: "El plazo estándar de recopilación ha finalizado. Puedes ampliar el plazo para recibir más contribuciones.",
        extendDays: "Días adicionales",
        extendConfirm: "Ampliar plazo",
        deadlineExtended: "Plazo ampliado correctamente",
        collectionDeadline: "Plazo de recopilación",
        collectionDeadlineExpired: "El plazo de recopilación ha vencido",
        daysRemaining: "días restantes",
        daysOverdue: "días de retraso"
      },
      orderTracking: {
        orderNotFound: "Pedido no encontrado",
        backToPanel: "Volver al panel",
        order: "Pedido",
        orderStatus: "Estado del pedido",
        inProgress: "En progreso",
        trackingNumber: "Número de seguimiento",
        orderDetails: "Detalles del pedido",
        copies: "ejemplares",
        copy: "ejemplar",
        shippingAddress: "Dirección de envío",
        subtotal: "Subtotal",
        shippingCost: "Envío",
        orderDate: "Pedido realizado",
        paymentSecure: "Pago seguro con"
      },
      common: {
        loading: "Cargando...",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        back: "Volver",
        next: "Siguiente",
        previous: "Anterior",
        finish: "Finalizar",
        select: "Selecciona...",
        normal: "Normal",
        noName: "Sin nombre"
      },
      coverEditor: {
        editorTitle: "Editor de plantilla",
        coverName: "Nombre de la portada",
        uploadCoverImage: "Sube una imagen de portada",
        backgroundType: "Tipo de fondo",
        protagonistPhoto: "Foto del protagonista",
        templateImage: "Imagen de la plantilla",
        photoFrame: "Marco de foto",
        hide: "Ocultar",
        fullPhoto: "Foto completa de fondo",
        framedPhoto: "Foto enmarcada",
        oval: "Ovalo",
        circle: "Circulo",
        rectangle: "Rectangulo",
        horizontalPos: "Pos. horizontal",
        verticalPos: "Pos. vertical",
        width: "Ancho",
        height: "Alto",
        rotation: "Rotacion",
        coverBackground: "Fondo de la portada",
        uploading: "Subiendo...",
        changeBgImage: "Cambiar imagen de fondo",
        uploadBgImage: "Subir imagen de fondo",
        changeBgDesign: "Cambiar diseno de fondo",
        uploadCover: "Subir imagen de portada",
        posHorizontal: "Posicion horizontal",
        posVertical: "Posicion vertical",
        fontSize: "Tamano de fuente",
        color: "Color",
        typography: "Tipografia",
        weight: "Grosor",
        transform: "Transformacion",
        uppercase: "MAYUSCULAS",
        capitalize: "Capitalizar",
        alignment: "Alineacion",
        alignLeft: "Izquierda",
        alignCenter: "Centro",
        alignRight: "Derecha",
        templateSaved: "Plantilla guardada",
        saveError: "Error al guardar",
        imageUpdated: "Imagen actualizada",
        uploadError: "Error al subir imagen",
        frameAutoNote: "La foto del protagonista se colocara automaticamente en el marco al seleccionar esta plantilla en un libro.",
        fieldProtagonistName: "Nombre del protagonista",
        fieldSubtitle: "Subtitulo",
        fieldTitle: "Titulo del libro",
        fieldBranding: "Marca (A Gift of Memories)"
      },
      notifications: {
        loadingTemplates: "Cargando plantillas...",
        errorLoadingTemplates: "Error al cargar plantillas de notificacion",
        errorLoadingLogs: "Error al cargar registros de email",
        testEmailSent: "Email de prueba enviado a",
        testEmailError: "Error al enviar email de prueba",
        templateUpdated: "Plantilla actualizada",
        templateCreated: "Plantilla creada",
        saveError: "Error al guardar",
        templateDeleted: "Plantilla eliminada",
        deleteError: "Error al eliminar",
        copiedToClipboard: "copiado al portapapeles",
        inactive: "Inactiva",
        emailChannel: "Email",
        subject: "Asunto",
        whatsappChannel: "WhatsApp",
        templatesTitle: "Plantillas de notificacion",
        templatesDesc: "Gestiona los correos y mensajes que se envian a clientes y colaboradores",
        templates: "Plantillas",
        sendLogs: "Registro de envios",
        newTemplate: "Nueva plantilla",
        clientNotifications: "Notificaciones al cliente",
        noClientTemplates: "No hay plantillas para clientes",
        collaboratorNotifications: "Notificaciones al colaborador",
        noCollabTemplates: "No hay plantillas para colaboradores",
        loadingLogs: "Cargando registros...",
        noLogs: "No hay registros de envio",
        colStatus: "Estado",
        colRecipient: "Destinatario",
        colSubjectEvent: "Asunto / Evento",
        colType: "Tipo",
        colDate: "Fecha",
        test: "Prueba",
        real: "Real",
        editTemplate: "Editar plantilla",
        name: "Nombre",
        templateName: "Nombre de la plantilla",
        recipientType: "Destinatario",
        client: "Cliente",
        collaborator: "Colaborador",
        order: "Orden",
        event: "Evento",
        active: "Activa",
        availableVariables: "Variables disponibles (clic para copiar)",
        emailSubject: "Asunto",
        emailSubjectPlaceholder: "Asunto del email",
        body: "Cuerpo",
        emailBodyPlaceholder: "Contenido del email. Usa {{variable}} para datos dinamicos.",
        message: "Mensaje",
        whatsappPlaceholder: "Mensaje de WhatsApp. Usa {{variable}} para datos dinamicos.",
        saving: "Guardando...",
        sendTestEmail: "Enviar email de prueba",
        template: "Plantilla",
        testEmailDesc: "Se enviara con datos de ejemplo para verificar el formato y la recepcion del email.",
        emailRecipient: "Email destinatario",
        sending: "Enviando...",
        sendTest: "Enviar prueba",
        deleteTemplate: "Eliminar plantilla",
        deleteWarning: "Esta accion no se puede deshacer. La plantilla de notificacion sera eliminada permanentemente.",
        sendTestTitle: "Enviar email de prueba"
      },
      formEditor: {
        shortText: "Texto corto",
        longText: "Texto largo",
        selector: "Selector",
        options: "Opciones",
        scale: "Escala",
        photos: "Imagenes (max 2)",
        label: "Etiqueta",
        type: "Tipo",
        placeholder: "Placeholder",
        helpText: "Texto de ayuda...",
        required: "Obligatorio",
        optionLabel: "Etiqueta",
        optionValue: "Valor",
        addOption: "Opcion",
        min: "Min",
        max: "Max",
        sectionTitle: "Titulo de seccion",
        description: "Descripcion",
        repeatable: "Repetible",
        maxRepeat: "Max repeticiones:",
        maxShort: "Max:",
        fields: "campos",
        repeatableTag: "Repetible",
        loadingForm: "Cargando formulario...",
        loadError: "Error al cargar",
        formLoadError: "Error al cargar el formulario",
        customizeDesc: "Personaliza las preguntas que veran los colaboradores al aportar sus historias.",
        restore: "Restaurar",
        formSaved: "Formulario guardado",
        formSaveError: "Error al guardar",
        formRestored: "Formulario restaurado a valores por defecto",
        restoreError: "Error al restaurar",
        newSection: "Nueva seccion",
        newField: "Nuevo campo",
        addField: "Anadir campo",
        addSection: "Anadir seccion"
      },
      bookDetailExtra: {
        pages: "Paginas",
        generationError: "Error en la generacion",
        preparingBook: "Preparando tu libro",
        generatingAI: "Generando el libro con IA...",
        pagesGenerated: "Paginas generadas",
        bookTitle: "Titulo del libro",
        coverDesign: "Diseno de portada",
        selectCoverStyle: "Selecciona un estilo de portada:",
        aBookFor: "Un libro para",
        coverPreview: "Vista previa de la portada",
        protagonistPhotoLabel: "Foto del protagonista",
        adjustPhoto: "Ajustar foto",
        zoom: "Zoom",
        saving: "Guardando...",
        sendReminder: "Recordatorio",
        reminderSent: "Recordatorio enviado",
        reminderError: "Error al enviar recordatorio"
      },
      contributionExtra: {
        loadingForm: "Cargando formulario...",
        invalidLink: "Enlace no valido",
        invalidLinkDesc: "Este enlace de contribucion no existe o ha expirado.",
        thanksTitle: "Gracias por tu aportacion",
        contributeToBook: "Contribuye al libro de",
        step: "Paso",
        of: "de",
        needsMoreContent: "Tu aportacion necesita mas contenido",
        generatingExpanded: "Generando contenido ampliado...",
        expandingAI: "La IA esta enriqueciendo tus anecdotas. Esto puede tardar unos segundos.",
        expandedReady: "Contenido ampliado listo",
        editComfortably: "Edita el contenido con mas espacio y comodidad",
        contentAccepted: "Contenido aceptado"
      },
      adminExtra: {
        noAssignedTasks: "No tienes tareas asignadas",
        noTeamTasks: "No hay tareas de equipo pendientes",
        pagesCol: "Paginas",
        estimatedDelivery: "Entrega estimada",
        templateRepo: "Repositorio de Plantillas",
        allProfiles: "Todos los perfiles",
        noTemplates: "No hay plantillas",
        unassigned: "Sin asignar"
      },
      clientForm: {
        title: "Formulario del protagonista",
        completed: "Completado",
        completedDesc: "Ya has rellenado la informacion sobre el protagonista. Puedes editarla en cualquier momento.",
        pendingDesc: "Rellena este formulario con informacion sobre el protagonista del libro. Nos ayudara a crear un libro mas rico y personalizado.",
        saved: "Formulario guardado correctamente",
        saveError: "Error al guardar el formulario",
        save: "Guardar formulario",
        saving: "Guardando...",
        addAnother: "Anadir otro"
      },
      billing: {
        checkout: "Pago",
        checkoutDesc: "Revisa tu pedido y completa el pago",
        orderSummary: "Resumen del pedido",
        personalizedBook: "Libro personalizado",
        firstCopy: "Primer ejemplar",
        extraCopies: "ejemplares extra",
        extraCopy: "ejemplar extra",
        collaboratorShipping: "Envio colaboradores",
        addresses: "direcciones",
        subtotal: "Subtotal",
        discount: "Descuento",
        tax: "IVA",
        total: "Total",
        couponCode: "Codigo de cupon",
        couponPlaceholder: "Introduce tu codigo",
        applyCoupon: "Aplicar",
        couponApplied: "Cupon aplicado correctamente",
        couponInvalid: "Cupon no valido o expirado",
        couponRemove: "Quitar",
        billingInfo: "Datos de facturacion",
        billingInfoDesc: "Estos datos apareceran en tu factura",
        name: "Nombre completo",
        company: "Empresa (opcional)",
        nif: "NIF / CIF",
        address: "Direccion",
        city: "Ciudad",
        postalCode: "Codigo postal",
        email: "Email de facturacion",
        payAndCreate: "Pagar y crear libro",
        processing: "Procesando pago...",
        paymentSuccess: "Pago realizado correctamente",
        paymentError: "Error al procesar el pago",
        paymentSimulated: "Pago simulado",
        confirmOrder: "Confirmar pedido",
        confirmOrderDesc: "Elige cuantos ejemplares quieres antes de enviar a imprenta",
        copies: "Numero de ejemplares",
        allowCollabPurchase: "Permitir a los colaboradores comprar el libro",
        allowCollabPurchaseDesc: "Los colaboradores podran pedir su propio ejemplar por 20€ + 5€ de envio.",
        deliveryEstimate: "Entrega estimada: 15-20 dias",
        bookSpecs: "Tapa blanda · A5 · 200 paginas",
        confirm: "Confirmar",
        invoices: "Facturas",
        noInvoices: "No tienes facturas todavia",
        noInvoicesDesc: "Las facturas se generaran automaticamente cuando realices un pedido",
        invoiceNumber: "N° Factura",
        invoiceDate: "Fecha",
        invoiceType: "Tipo",
        invoiceTotal: "Total",
        invoiceStatus: "Estado",
        downloadPdf: "Descargar PDF",
        typeInitial: "Libro",
        typeExtras: "Extras",
        statusPaid: "Pagada",
        statusPending: "Pendiente",
        inclTax: "IVA incluido"
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        howItWorks: "How It Works",
        pricing: "Pricing",
        login: "Sign In",
        register: "Sign Up",
        dashboard: "Dashboard",
        admin: "Admin",
        help: "Help",
        logout: "Sign Out"
      },
      help: {
        title: "Help Center",
        subtitle: "Get answers from the assistant or contact us directly.",
        tabs: { chatbot: "AI Assistant", faqs: "FAQs", tour: "Guided Tour", contact: "Contact" },
        floating: { tooltip: "Help" },
        tour: {
          title: "Guided app tour",
          description: "A 60-second visual walkthrough of all main features.",
          start: "Start tour", restart: "Restart tour", resetBtn: "Mark as not seen",
          reset: "Tour reset. It will appear next time you log in.",
          back: "Back", close: "Close", last: "Finish", next: "Next", skip: "Skip",
          welcomeTitle: "Welcome to A Gift of Memories!",
          welcome: "We'll walk you through the app in 60 seconds. Use arrows to continue.",
          dashboard: "This is your main dashboard. You'll see all your active books and their status.",
          createBook: "Click here to create a new book. We'll guide you in 4 steps.",
          booksList: "All your books appear here. Click one to manage it.",
          invoices: "In this tab you can find your invoices and download them as PDF.",
          helpBtn: "Need help? Use this floating button anytime to open help.",
          endTitle: "All set!",
          end: "You now know the app. If you need more help, use the chatbot or FAQs."
        },
        chatbot: { title: "Memories Assistant", subtitle: "Ask me anything about the app", placeholder: "Type your question...", voiceOn: "Enable voice", voiceOff: "Voice enabled", listen: "Listen", stopListening: "Stop" },
        chatError: "Couldn't respond, please try again.",
        faqs: {
          searchPlaceholder: "Search FAQs...",
          noResults: "No results for your search",
          catAll: "All", catGeneral: "General", catStart: "Getting started", catContributors: "Contributors", catProcess: "Process", catAI: "Artificial Intelligence", catPricing: "Pricing & payment", catContent: "Book content", catPrivacy: "Privacy", catShipping: "Shipping", catSupport: "Support"
        },
        contact: {
          categoryLabel: "Inquiry type",
          catQuestion: "Question", catSuggestion: "Suggestion", catIncident: "Incident", catComplaint: "Complaint",
          name: "Name", email: "Email", subject: "Subject", message: "Message",
          privacy: "Your data is used only to respond to your inquiry.",
          submit: "Send message",
          sent: "Message sent! We'll get back to you soon.",
          error: "Error sending. Please try again.",
          fillAll: "Please fill in all fields",
          thanksTitle: "Message received!",
          thanksDesc: "We've sent a confirmation email. We'll respond within 24 business hours.",
          sendAnother: "Send another message"
        }
      },
      hero: {
        title: "Create a unique book full of memories",
        subtitle: "Collect stories from family and friends, and our AI will turn them into a beautiful personalized book",
        cta: "Create My Book"
      },
      profiles: {
        title: "For all ages",
        subtitle: "Personalized books adapted to every stage of life",
        child: "Children",
        childDesc: "Magical stories for the little ones",
        teen: "Teenagers",
        teenDesc: "Fun and meaningful memories",
        adult: "Adults",
        adultDesc: "Deep and emotional reflections",
        senior: "Seniors",
        seniorDesc: "Celebrating a lifetime",
        infantil: "Children",
        adolescente: "Teenagers",
        adulto: "Adults",
        tercera_edad: "Seniors",
        terceraedad: "Seniors"
      },
      howItWorks: {
        title: "How does it work?",
        subtitle: "In 4 simple steps you'll have an unforgettable gift",
        step1: {
          title: "Create your project",
          desc: "Choose the recipient's profile and special occasion"
        },
        step2: {
          title: "Invite contributors",
          desc: "Family and friends share their memories"
        },
        step3: {
          title: "We create a unique piece",
          desc: "We help you write the book with our AI agents"
        },
        step4: {
          title: "Receive your book",
          desc: "Premium printed and delivered to your door"
        }
      },
      pricing: {
        title: "Transparent pricing",
        subtitle: "No surprises, no hidden costs",
        basePrice: "60€",
        basePriceLabel: "first copy",
        extraPrice: "+20€",
        extraPriceLabel: "per extra copy",
        shippingCollaborators: "+5€ per address (if contributors buy)",
        deliveryTime: "Delivery in 15-20 days",
        features: {
          pages: "200 pages (black/white and color)",
          format: "Softcover, A5 size",
          contributors: "Unlimited contributors",
          ai: "Personalized AI generation",
          cover: "Custom front cover, spine and back cover",
          reviews: "AI-generated humorous reviews",
          extras: "Extra copies for family and friends"
        },
        collaboratorsNote: "Contributors can also buy their own copy (+20€ + 5€ shipping)",
        cta: "Start Now"
      },
      footer: {
        tagline: "Creating memories that last",
        rights: "All rights reserved"
      },
      auth: {
        login: "Sign In",
        register: "Create Account",
        email: "Email",
        password: "Password",
        name: "Full name",
        firstName: "First Name",
        lastName: "Last Name",
        phone: "Phone",
        forgotPassword: "Forgot password?",
        rememberMe: "Remember me",
        noAccount: "Don't have an account?",
        hasAccount: "Already have an account?",
        orContinueWith: "Or continue with",
        google: "Continue with Google",
        resetPassword: "Reset password",
        resetDescription: "Enter your email and we'll send you a link to reset your password",
        sendResetLink: "Send reset link",
        resetSent: "Link sent",
        resetSentDesc: "If an account exists with this email, you'll receive a password reset link",
        resetLinkPreview: "Reset link:",
        clickToReset: "Click here to reset your password",
        backToLogin: "Back to sign in",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        changePassword: "Change password",
        passwordMismatch: "Passwords don't match",
        passwordTooShort: "Password must be at least 6 characters",
        passwordResetSuccess: "Password changed successfully. Sign in with your new password",
        resetError: "Error resetting password",
        invalidToken: "Invalid link",
        invalidTokenDesc: "This link has expired or is invalid. Request a new one.",
        requestNewLink: "Request new link"
      },
      dashboard: {
        welcome: "Welcome",
        myBooks: "My Books",
        createNew: "Create New Book",
        noBooks: "No books yet",
        noBooksDesc: "Create your first personalized book",
        orders: "My Orders",
        noOrders: "No orders yet",
        noOrdersDesc: "When you order a book, it will appear here",
        book: "book",
        books: "books",
        filterAll: "All",
        filterActive: "Active",
        filterClosed: "Closed",
        noFilteredBooks: "No books match this filter",
        colTitle: "Title",
        colRecipient: "Recipient",
        colStatus: "Status",
        colDate: "Date",
        deleteBook: "Delete book",
        confirmDeleteBook: "Do you really want to delete this book",
        deleteBookWarning: "This action will permanently delete:",
        deleteBookData: "The book and all generated content",
        deleteBookContributors: "All assigned contributors",
        deleteBookContributions: "All received contributions",
        bookDeleted: "Book deleted successfully",
        myTasks: "My Pending Tasks",
        delayed: "Delayed",
        remaining: "remaining",
        onTrack: "On Track",
        pendingTasks: "pending tasks",
        noTasksDesc: "You have no pending tasks",
        changePhase: "Change phase",
        selectPhase: "Select phase",
        statusChanged: "Status changed successfully"
      },
      book: {
        create: "Create Book",
        title: "Book title",
        titlePlaceholder: "Ejem: Mary's Book",
        profile: "Recipient profile",
        recipientName: "Recipient name",
        recipientAge: "Age (optional)",
        relationship: "Your relationship with the recipient",
        occasion: "Special occasion",
        language: "Book language",
        coverStyle: "Cover style",
        contributors: "Contributors",
        addContributor: "Add contributor",
        contributions: "Received contributions",
        generate: "Generate Book",
        preview: "Preview",
        order: "Order Print",
        status: {
          collecting: "Collecting",
          generating: "Generating",
          ready: "Ready",
          ordered: "Ordered",
          shipped: "Shipped"
        }
      },
      contributor: {
        name: "Name",
        email: "Email",
        relationship: "Relationship",
        invite: "Send invitation",
        copyLink: "Copy link",
        linkCopied: "Link copied!",
        pending: "Pending",
        contributed: "Contributed"
      },
      contribution: {
        title: "Share your memory",
        welcome: "Welcome",
        forBook: "You're contributing to the book of",
        memoryTitle: "Memory title",
        memoryTitlePlaceholder: "Ejem: That summer at the beach",
        memoryContent: "Your story or memory",
        memoryContentPlaceholder: "Tell your story in detail...",
        memoryDate: "Approximate date (optional)",
        emotion: "How would you describe this memory?",
        emotions: {
          feliz: "Happy",
          divertido: "Funny",
          emotivo: "Emotional",
          inspirador: "Inspiring"
        },
        submit: "Submit Memory",
        thanks: "Thank you for your contribution!",
        alreadyContributed: "You have already submitted your contribution"
      },
      order: {
        checkout: "Checkout",
        summary: "Order summary",
        quantity: "Quantity",
        unitPrice: "Unit price",
        shipping: "Shipping",
        total: "Total",
        shippingInfo: "Shipping information",
        fullName: "Full name",
        address: "Address",
        city: "City",
        postalCode: "Postal code",
        country: "Country",
        phone: "Phone",
        payNow: "Pay Now",
        success: "Payment completed!",
        successDesc: "Your order is being processed",
        tracking: "Tracking",
        status: {
          pending: "Pending payment",
          paid: "Paid",
          processing: "Processing",
          printing: "Printing",
          shipped: "Shipped",
          delivered: "Delivered"
        }
      },
      admin: {
        title: "Admin Panel",
        subtitle: "Manage users and oversee the platform",
        refresh: "Refresh",
        totalUsers: "Total users",
        clients: "Clients",
        monthlyRevenue: "Revenue (month)",
        employees: "Employees",
        booksCreated: "Books created",
        totalOrders: "Total orders",
        newRecent: "New (7 days)",
        clientManagement: "Client Management",
        employeeManagement: "Employee Management",
        registeredUsers: "registered users",
        registeredClients: "registered clients",
        registeredEmployees: "registered employees",
        searchPlaceholder: "Search by name, email or phone...",
        user: "User",
        contact: "Contact",
        books: "Books",
        orders: "Orders",
        role: "Role",
        registered: "Registered",
        actions: "Actions",
        viewDetails: "View details",
        makeAdmin: "Make admin",
        removeAdmin: "Remove admin",
        deleteUser: "Delete",
        noUsersFound: "No users found",
        userDetails: "User Details",
        client: "Client",
        employee: "Employee",
        noBooks: "No books created",
        noOrders: "No orders",
        noEmployees: "No registered employees",
        noEmployeesDesc: "Convert client users to employees from the Clients tab",
        convertToEmployee: "Convert to employee",
        convertToClient: "Convert to client",
        convertedToEmployee: "User converted to employee",
        convertedToClient: "User converted to client",
        managePermissions: "Manage permissions",
        permissionsSaved: "Permissions updated",
        perm_manage_users: "User management",
        perm_manage_books: "Book management",
        perm_manage_orders: "Order management",
        perm_manage_contributions: "Contribution management",
        perm_view_stats: "View statistics",
        permDesc_manage_users: "Can view and manage user accounts",
        permDesc_manage_books: "Can view and manage all books",
        permDesc_manage_orders: "Can view and manage orders",
        permDesc_manage_contributions: "Can view and manage contributions",
        permDesc_view_stats: "Can view platform statistics",
        confirmDelete: "Delete User",
        confirmDeleteDesc: "Are you sure you want to delete",
        deleteWarning: "This action will permanently delete:",
        deleteAccount: "User account",
        deleteAllBooks: "All their books",
        deleteAllOrders: "All their orders",
        deleteContributions: "All associated contributions",
        cancel: "Cancel",
        userPromoted: "User promoted to admin",
        adminRemoved: "Admin permissions removed",
        userDeleted: "User deleted",
        bookDeleted: "Project deleted",
        editUser: "Edit user",
        createUser: "Create user",
        createClient: "New client",
        createEmployee: "New employee",
        userCreated: "User created successfully",
        userUpdated: "User updated successfully",
        fillRequired: "Fill in required fields (name, email, password)",
        leaveBlankKeep: "leave blank to keep current",
        deleteBook: "Delete project",
        confirmDeleteBookDesc: "Do you really want to delete this project",
        deleteBookWarning: "This action will permanently delete:",
        deleteBookData: "The project and all its content",
        deleteBookContributors: "All assigned contributors",
        deleteBookContributions: "All received contributions",
        deleteBookOrders: "Associated orders",
        accessDenied: "Access denied",
        noAdminPermissions: "You don't have admin permissions",
        noName: "No name",
        bookStatusManagement: "Book Status Management",
        totalBooks: "total books",
        searchBooks: "Search by title, owner or email...",
        owner: "Owner",
        noBooksFound: "No books found",
        statusUpdated: "Status updated successfully",
        bookStatus: {
          alta: "New",
          recopilando: "Collecting",
          generando: "Generating",
          en_revision: "In Review",
          revisado: "Reviewed",
          listo_impresion: "Ready to Print",
          enviado_imprenta: "Sent to Printer",
          recibido_imprenta: "Received from Printer",
          recibido: "Received",
          revision_imprenta: "Print Review",
          envio_prueba: "Proof Sent",
          preparacion_imprenta: "Print Preparation",
          envio_imprenta: "Sent to Printer",
          envio_cliente: "Sent to Client",
          recibido_cliente: "Received by Client",
          generado: "Generated",
          ok_prueba: "Proof Approved",
          regenerando: "Regenerating",
          collecting: "Collecting",
          generating: "Generating",
          review: "In Review",
          reviewed: "Reviewed",
          ready_print: "Ready to Print",
          sent_print: "Sent to Print",
          sent_client: "Sent to Client",
          delivered: "Delivered",
          ready: "Ready",
          ordered: "Ordered"
        },
        tracking: "Tracking",
        trackingOnTrack: "On Track",
        trackingDelayed: "Delayed",
        trackingCompleted: "Completed",
        phaseConfig: "Configure Times",
        phaseConfigDesc: "Set the standard time (in days) for each book phase",
        phaseConfigSaved: "Phase times saved",
        phaseConfigApplied: "Times applied to {{count}} books",
        applyToAllBooks: "Apply to all books",
        phaseDetail: "Phase Detail",
        phaseTimeUpdated: "Phase time updated",
        currentPhase: "Current phase",
        viewPhases: "View phases",
        days: "days",
        defaultPhases: "Default assigned phases",
        assignmentSaved: "Assignment saved",
        unassigned: "Unassigned",
        responsible: "Responsible",
        phase: "Phase",
        timing: "Timing",
        dueDate: "Due Date",
        pendingTasks: "Pending Tasks",
        taskAssignPhases: "Assign responsibles",
        assignResponsibles: "Assign",
        taskCompleted: "Task completed",
        createdBy: "Created by"
      },
      createBook: {
        whoIsBookFor: "Who is the book for?",
        selectProfile: "Select the recipient's profile",
        bookDetails: "Book details",
        tellUsMore: "Tell us more about the recipient",
        customization: "Customization",
        chooseLanguageStyle: "Choose the book language and style",
        step: "Step",
        of: "of",
        summary: "Summary",
        bookCreated: "Book created successfully!",
        errorCreating: "Error creating book",
        otherOccasion: "Specify the occasion",
        otherOccasionPlaceholder: "E.g.: Tribute, Baptism, Communion..."
      },
      occasions: {
        cumpleanos: "Birthday",
        navidad: "Christmas",
        jubilacion: "Retirement",
        aniversario: "Anniversary",
        graduacion: "Graduation",
        dia_madre: "Mother's Day",
        dia_padre: "Father's Day",
        otro: "Other occasion"
      },
      coverStyles: {
        classic: "Classic",
        classicDesc: "Elegant and timeless",
        modern: "Modern",
        modernDesc: "Minimalist and fresh",
        playful: "Playful",
        playfulDesc: "Colorful and cheerful",
        vintage: "Vintage",
        vintageDesc: "Nostalgic and warm"
      },
      bookDetail: {
        backToDashboard: "Back to dashboard",
        for: "For",
        collaborators: "Collaborators",
        contributions: "Contributions",
        language: "Language",
        created: "Created",
        collaboratorList: "Contributor list",
        noCollaborators: "No contributors yet",
        noCollaboratorsDesc: "Invite family and friends to share their memories",
        noContributions: "No contributions yet",
        noContributionsDesc: "Contributions will appear here when contributors send their memories",
        addCollaboratorGuest: "Add contributor / guest",
        tableNumber: "Table No.",
        selectTable: "Select table...",
        dietType: "Diet Type",
        selectDiet: "Select diet...",
        openLink: "Open link",
        deleteCollaborator: "Delete contributor",
        confirmDeleteDesc: "Are you sure you want to delete",
        contributorAlreadyContributed: "This contributor has already submitted their contribution. If you delete them, their contribution will also be removed.",
        completeRequired: "Complete the required fields",
        collaboratorAdded: "Contributor added",
        collaboratorDeleted: "Contributor deleted",
        needContribution: "You need at least one contribution to generate the book",
        generating: "Generating...",
        bookGenerated: "Book generated successfully!",
        bookPreview: "Book preview",
        previewDesc: "AI-generated content based on contributions",
        by: "By",
        confirmCollection: "Confirm collection complete",
        confirmCollectionDesc: "Confirm you have received enough contributions? The book will move to generation phase.",
        confirmCollectionBtn: "Confirm and generate book",
        collectionConfirmed: "Collection confirmed. Book moves to generation.",
        extendDeadline: "Extend deadline",
        extendDeadlineDesc: "The standard collection period has ended. You can extend the deadline to receive more contributions.",
        extendDays: "Additional days",
        extendConfirm: "Extend deadline",
        deadlineExtended: "Deadline extended successfully",
        collectionDeadline: "Collection deadline",
        collectionDeadlineExpired: "Collection deadline has expired",
        daysRemaining: "days remaining",
        daysOverdue: "days overdue"
      },
      orderTracking: {
        orderNotFound: "Order not found",
        backToPanel: "Back to dashboard",
        order: "Order",
        orderStatus: "Order status",
        inProgress: "In progress",
        trackingNumber: "Tracking number",
        orderDetails: "Order details",
        copies: "copies",
        copy: "copy",
        shippingAddress: "Shipping address",
        subtotal: "Subtotal",
        shippingCost: "Shipping",
        orderDate: "Order placed",
        paymentSecure: "Secure payment with"
      },
      common: {
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        back: "Back",
        next: "Next",
        previous: "Previous",
        finish: "Finish",
        select: "Select...",
        normal: "Normal",
        noName: "No name"
      },
      coverEditor: {
        editorTitle: "Template Editor",
        coverName: "Cover name",
        uploadCoverImage: "Upload a cover image",
        backgroundType: "Background type",
        protagonistPhoto: "Protagonist photo",
        templateImage: "Template image",
        photoFrame: "Photo frame",
        hide: "Hide",
        fullPhoto: "Full background photo",
        framedPhoto: "Framed photo",
        oval: "Oval",
        circle: "Circle",
        rectangle: "Rectangle",
        horizontalPos: "Horizontal pos.",
        verticalPos: "Vertical pos.",
        width: "Width",
        height: "Height",
        rotation: "Rotation",
        coverBackground: "Cover background",
        uploading: "Uploading...",
        changeBgImage: "Change background image",
        uploadBgImage: "Upload background image",
        changeBgDesign: "Change background design",
        uploadCover: "Upload cover image",
        posHorizontal: "Horizontal position",
        posVertical: "Vertical position",
        fontSize: "Font size",
        color: "Color",
        typography: "Typography",
        weight: "Weight",
        transform: "Transform",
        uppercase: "UPPERCASE",
        capitalize: "Capitalize",
        alignment: "Alignment",
        alignLeft: "Left",
        alignCenter: "Center",
        alignRight: "Right",
        templateSaved: "Template saved",
        saveError: "Error saving",
        imageUpdated: "Image updated",
        uploadError: "Error uploading image",
        frameAutoNote: "The protagonist's photo will be automatically placed in the frame when selecting this template for a book.",
        fieldProtagonistName: "Protagonist name",
        fieldSubtitle: "Subtitle",
        fieldTitle: "Book title",
        fieldBranding: "Branding (A Gift of Memories)"
      },
      notifications: {
        loadingTemplates: "Loading templates...",
        errorLoadingTemplates: "Error loading notification templates",
        errorLoadingLogs: "Error loading email logs",
        testEmailSent: "Test email sent to",
        testEmailError: "Error sending test email",
        templateUpdated: "Template updated",
        templateCreated: "Template created",
        saveError: "Error saving",
        templateDeleted: "Template deleted",
        deleteError: "Error deleting",
        copiedToClipboard: "copied to clipboard",
        inactive: "Inactive",
        emailChannel: "Email",
        subject: "Subject",
        whatsappChannel: "WhatsApp",
        templatesTitle: "Notification templates",
        templatesDesc: "Manage emails and messages sent to clients and contributors",
        templates: "Templates",
        sendLogs: "Send logs",
        newTemplate: "New template",
        clientNotifications: "Client notifications",
        noClientTemplates: "No client templates",
        collaboratorNotifications: "Contributor notifications",
        noCollabTemplates: "No contributor templates",
        loadingLogs: "Loading logs...",
        noLogs: "No send logs",
        colStatus: "Status",
        colRecipient: "Recipient",
        colSubjectEvent: "Subject / Event",
        colType: "Type",
        colDate: "Date",
        test: "Test",
        real: "Real",
        editTemplate: "Edit template",
        name: "Name",
        templateName: "Template name",
        recipientType: "Recipient",
        client: "Client",
        collaborator: "Contributor",
        order: "Order",
        event: "Event",
        active: "Active",
        availableVariables: "Available variables (click to copy)",
        emailSubject: "Subject",
        emailSubjectPlaceholder: "Email subject",
        body: "Body",
        emailBodyPlaceholder: "Email content. Use {{variable}} for dynamic data.",
        message: "Message",
        whatsappPlaceholder: "WhatsApp message. Use {{variable}} for dynamic data.",
        saving: "Saving...",
        sendTestEmail: "Send test email",
        template: "Template",
        testEmailDesc: "Will be sent with sample data to verify email format and delivery.",
        emailRecipient: "Recipient email",
        sending: "Sending...",
        sendTest: "Send test",
        deleteTemplate: "Delete template",
        deleteWarning: "This action cannot be undone. The notification template will be permanently deleted.",
        sendTestTitle: "Send test email"
      },
      formEditor: {
        shortText: "Short text",
        longText: "Long text",
        selector: "Selector",
        options: "Options",
        scale: "Scale",
        photos: "Images (max 2)",
        label: "Label",
        type: "Type",
        placeholder: "Placeholder",
        helpText: "Help text...",
        required: "Required",
        optionLabel: "Label",
        optionValue: "Value",
        addOption: "Option",
        min: "Min",
        max: "Max",
        sectionTitle: "Section title",
        description: "Description",
        repeatable: "Repeatable",
        maxRepeat: "Max repetitions:",
        maxShort: "Max:",
        fields: "fields",
        repeatableTag: "Repeatable",
        loadingForm: "Loading form...",
        loadError: "Error loading",
        formLoadError: "Error loading the form",
        customizeDesc: "Customize the questions contributors will see when sharing their stories.",
        restore: "Restore",
        formSaved: "Form saved",
        formSaveError: "Error saving",
        formRestored: "Form restored to defaults",
        restoreError: "Error restoring",
        newSection: "New section",
        newField: "New field",
        addField: "Add field",
        addSection: "Add section"
      },
      bookDetailExtra: {
        pages: "Pages",
        generationError: "Generation error",
        preparingBook: "Preparing your book",
        generatingAI: "Generating the book with AI...",
        pagesGenerated: "Pages generated",
        bookTitle: "Book title",
        coverDesign: "Cover design",
        selectCoverStyle: "Select a cover style:",
        aBookFor: "A book for",
        coverPreview: "Cover preview",
        protagonistPhotoLabel: "Protagonist photo",
        adjustPhoto: "Adjust photo",
        zoom: "Zoom",
        saving: "Saving...",
        sendReminder: "Reminder",
        reminderSent: "Reminder sent",
        reminderError: "Error sending reminder"
      },
      contributionExtra: {
        loadingForm: "Loading form...",
        invalidLink: "Invalid link",
        invalidLinkDesc: "This contribution link does not exist or has expired.",
        thanksTitle: "Thank you for your contribution",
        contributeToBook: "Contribute to the book of",
        step: "Step",
        of: "of",
        needsMoreContent: "Your contribution needs more content",
        generatingExpanded: "Generating expanded content...",
        expandingAI: "AI is enriching your stories. This may take a few seconds.",
        expandedReady: "Expanded content ready",
        editComfortably: "Edit the content with more space and comfort",
        contentAccepted: "Content accepted"
      },
      adminExtra: {
        noAssignedTasks: "You have no assigned tasks",
        noTeamTasks: "No pending team tasks",
        pagesCol: "Pages",
        estimatedDelivery: "Estimated delivery",
        templateRepo: "Template Repository",
        allProfiles: "All profiles",
        noTemplates: "No templates",
        unassigned: "Unassigned"
      },
      clientForm: {
        title: "Protagonist questionnaire",
        completed: "Completed",
        completedDesc: "You have already filled in the protagonist's information. You can edit it at any time.",
        pendingDesc: "Fill out this form with information about the book's protagonist. It will help us create a richer, more personalized book.",
        saved: "Form saved successfully",
        saveError: "Error saving form",
        save: "Save form",
        saving: "Saving...",
        addAnother: "Add another"
      },
      billing: {
        checkout: "Checkout",
        checkoutDesc: "Review your order and complete payment",
        orderSummary: "Order summary",
        personalizedBook: "Personalized book",
        firstCopy: "First copy",
        extraCopies: "extra copies",
        extraCopy: "extra copy",
        collaboratorShipping: "Collaborator shipping",
        addresses: "addresses",
        subtotal: "Subtotal",
        discount: "Discount",
        tax: "VAT",
        total: "Total",
        couponCode: "Coupon code",
        couponPlaceholder: "Enter your code",
        applyCoupon: "Apply",
        couponApplied: "Coupon applied successfully",
        couponInvalid: "Invalid or expired coupon",
        couponRemove: "Remove",
        billingInfo: "Billing information",
        billingInfoDesc: "This information will appear on your invoice",
        name: "Full name",
        company: "Company (optional)",
        nif: "Tax ID",
        address: "Address",
        city: "City",
        postalCode: "Postal code",
        email: "Billing email",
        payAndCreate: "Pay and create book",
        processing: "Processing payment...",
        paymentSuccess: "Payment completed successfully",
        paymentError: "Error processing payment",
        paymentSimulated: "Simulated payment",
        confirmOrder: "Confirm order",
        confirmOrderDesc: "Choose how many copies you want before sending to print",
        copies: "Number of copies",
        allowCollabPurchase: "Allow collaborators to buy the book",
        allowCollabPurchaseDesc: "Collaborators can order their own copy for 20€ + 5€ shipping.",
        deliveryEstimate: "Estimated delivery: 15-20 days",
        bookSpecs: "Softcover · A5 · 200 pages",
        confirm: "Confirm",
        invoices: "Invoices",
        noInvoices: "No invoices yet",
        noInvoicesDesc: "Invoices will be generated automatically when you place an order",
        invoiceNumber: "Invoice #",
        invoiceDate: "Date",
        invoiceType: "Type",
        invoiceTotal: "Total",
        invoiceStatus: "Status",
        downloadPdf: "Download PDF",
        typeInitial: "Book",
        typeExtras: "Extras",
        statusPaid: "Paid",
        statusPending: "Pending",
        inclTax: "VAT included"
      }
    }
  },
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        howItWorks: "Comment ça marche",
        pricing: "Tarifs",
        login: "Connexion",
        register: "S'inscrire",
        dashboard: "Tableau de bord",
        admin: "Admin",
        help: "Aide",
        logout: "Déconnexion"
      },
      help: {
        title: "Centre d'aide",
        subtitle: "Obtenez des réponses de l'assistant ou contactez-nous.",
        tabs: { chatbot: "Assistant IA", faqs: "FAQ", tour: "Visite guidée", contact: "Contact" },
        floating: { tooltip: "Aide" },
        tour: {
          title: "Visite guidée de l'app",
          description: "Un tour visuel de 60 secondes des principales fonctions.",
          start: "Commencer", restart: "Recommencer", resetBtn: "Marquer comme non vu",
          reset: "Visite réinitialisée. Elle s'affichera à la prochaine connexion.",
          back: "Retour", close: "Fermer", last: "Terminer", next: "Suivant", skip: "Passer",
          welcomeTitle: "Bienvenue chez A Gift of Memories !",
          welcome: "Nous vous guidons en 60 secondes. Utilisez les flèches pour continuer.",
          dashboard: "Voici votre tableau de bord. Vous y verrez tous vos livres actifs.",
          createBook: "Cliquez ici pour créer un nouveau livre en 4 étapes.",
          booksList: "Tous vos livres apparaissent ici. Cliquez pour gérer.",
          invoices: "Dans cet onglet, retrouvez vos factures et téléchargez-les en PDF.",
          helpBtn: "Besoin d'aide ? Utilisez ce bouton flottant à tout moment.",
          endTitle: "Parfait !",
          end: "Vous connaissez l'app. Pour plus d'aide, utilisez le chatbot ou les FAQ."
        },
        chatbot: { title: "Assistant Memories", subtitle: "Posez-moi toutes vos questions", placeholder: "Écrivez votre question...", voiceOn: "Activer la voix", voiceOff: "Voix activée", listen: "Écouter", stopListening: "Arrêter" },
        chatError: "Je n'ai pas pu répondre, réessayez.",
        faqs: {
          searchPlaceholder: "Rechercher dans les FAQ...",
          noResults: "Aucun résultat",
          catAll: "Toutes", catGeneral: "Général", catStart: "Premiers pas", catContributors: "Contributeurs", catProcess: "Processus", catAI: "Intelligence Artificielle", catPricing: "Prix et paiement", catContent: "Contenu du livre", catPrivacy: "Confidentialité", catShipping: "Livraison", catSupport: "Support"
        },
        contact: {
          categoryLabel: "Type de demande",
          catQuestion: "Question", catSuggestion: "Suggestion", catIncident: "Incident", catComplaint: "Réclamation",
          name: "Nom", email: "Email", subject: "Sujet", message: "Message",
          privacy: "Vos données servent uniquement à répondre à votre demande.",
          submit: "Envoyer",
          sent: "Message envoyé ! Nous vous répondrons bientôt.",
          error: "Erreur d'envoi. Réessayez.",
          fillAll: "Veuillez remplir tous les champs",
          thanksTitle: "Message reçu !",
          thanksDesc: "Un email de confirmation a été envoyé. Nous répondons sous 24h ouvrables.",
          sendAnother: "Envoyer un autre message"
        }
      },
      hero: {
        title: "Créez un livre unique rempli de souvenirs",
        subtitle: "Collectez des histoires de famille et d'amis, et notre IA les transformera en un beau livre personnalisé",
        cta: "Créer Mon Livre"
      },
      profiles: {
        title: "Pour tous les âges",
        subtitle: "Des livres personnalisés adaptés à chaque étape de la vie",
        child: "Enfants",
        childDesc: "Des histoires magiques pour les petits",
        teen: "Adolescents",
        teenDesc: "Des souvenirs amusants et significatifs",
        adult: "Adultes",
        adultDesc: "Des réflexions profondes et émouvantes",
        senior: "Seniors",
        seniorDesc: "Célébrer toute une vie",
        infantil: "Enfants",
        adolescente: "Adolescents",
        adulto: "Adultes",
        tercera_edad: "Seniors",
        terceraedad: "Seniors"
      },
      howItWorks: {
        title: "Comment ça marche?",
        subtitle: "En 4 étapes simples, vous aurez un cadeau inoubliable",
        step1: { title: "Créez votre projet", desc: "Choisissez le profil du destinataire et l'occasion spéciale" },
        step2: { title: "Invitez des contributeurs", desc: "Famille et amis partagent leurs souvenirs" },
        step3: { title: "Nous créons une pièce unique", desc: "Nous vous aidons à rédiger le livre avec nos agents d'IA" },
        step4: { title: "Recevez votre livre", desc: "Imprimé en qualité premium et livré chez vous" }
      },
      pricing: {
        title: "Prix transparent",
        subtitle: "Sans surprises, sans coûts cachés",
        basePrice: "60€", basePriceLabel: "premier exemplaire",
        extraPrice: "+20€", extraPriceLabel: "par exemplaire supplémentaire",
        shippingCollaborators: "+5€ par adresse (si contributeurs achètent)",
        deliveryTime: "Livraison en 15-20 jours",
        features: { pages: "200 pages (noir/blanc et couleur)", format: "Couverture souple, format A5", contributors: "Contributeurs illimités", ai: "Génération IA personnalisée", cover: "Couverture, dos et quatrième personnalisés", reviews: "Critiques humoristiques générées par IA", extras: "Exemplaires supplémentaires pour famille et amis" },
        collaboratorsNote: "Les contributeurs peuvent aussi acheter leur exemplaire (+20€ + 5€ livraison)",
        cta: "Commencer"
      },
      footer: { tagline: "Créer des souvenirs qui durent", rights: "Tous droits réservés" },
      auth: { login: "Connexion", register: "Créer un compte", email: "Email", password: "Mot de passe", name: "Nom complet", firstName: "Prénom", lastName: "Nom", phone: "Téléphone", forgotPassword: "Mot de passe oublié?", rememberMe: "Se souvenir de moi", noAccount: "Pas de compte?", hasAccount: "Déjà un compte?", orContinueWith: "Ou continuer avec", google: "Continuer avec Google", resetPassword: "Réinitialiser le mot de passe", resetDescription: "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe", sendResetLink: "Envoyer le lien", resetSent: "Lien envoyé", resetSentDesc: "Si un compte existe avec cet email, vous recevrez un lien de réinitialisation", resetLinkPreview: "Lien de réinitialisation:", clickToReset: "Cliquez ici pour réinitialiser votre mot de passe", backToLogin: "Retour à la connexion", newPassword: "Nouveau mot de passe", confirmPassword: "Confirmer le mot de passe", changePassword: "Changer le mot de passe", passwordMismatch: "Les mots de passe ne correspondent pas", passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères", passwordResetSuccess: "Mot de passe changé avec succès. Connectez-vous avec votre nouveau mot de passe", resetError: "Erreur lors de la réinitialisation", invalidToken: "Lien invalide", invalidTokenDesc: "Ce lien a expiré ou est invalide. Demandez-en un nouveau.", requestNewLink: "Demander un nouveau lien" },
      dashboard: { welcome: "Bienvenue", myBooks: "Mes Livres", createNew: "Créer un nouveau livre", noBooks: "Pas encore de livres", noBooksDesc: "Créez votre premier livre personnalisé", orders: "Mes Commandes", noOrders: "Pas encore de commandes", noOrdersDesc: "Quand vous commanderez un livre, il apparaîtra ici", book: "livre", books: "livres", filterAll: "Tous", filterActive: "Actifs", filterClosed: "Fermés", noFilteredBooks: "Aucun livre ne correspond à ce filtre", colTitle: "Titre", colRecipient: "Destinataire", colStatus: "Statut", colDate: "Date", deleteBook: "Supprimer le livre", confirmDeleteBook: "Voulez-vous vraiment supprimer ce livre", deleteBookWarning: "Cette action supprimera définitivement:", deleteBookData: "Le livre et tout le contenu généré", deleteBookContributors: "Tous les contributeurs assignés", deleteBookContributions: "Toutes les contributions reçues", bookDeleted: "Livre supprimé avec succès", myTasks: "Mes tâches en attente", delayed: "En retard", remaining: "restants", onTrack: "Dans les délais", pendingTasks: "tâches en attente", noTasksDesc: "Vous n'avez pas de tâches en attente", changePhase: "Changer la phase", selectPhase: "Sélectionner la phase", statusChanged: "Statut modifié avec succès" },
      book: { create: "Créer un livre", title: "Titre du livre", titlePlaceholder: "Ejem: Le livre de Marie", profile: "Profil du destinataire", recipientName: "Nom du destinataire", recipientAge: "Âge (optionnel)", relationship: "Votre relation avec le destinataire", occasion: "Occasion spéciale", language: "Langue du livre", coverStyle: "Style de couverture", contributors: "Contributeurs", addContributor: "Ajouter un contributeur", contributions: "Contributions reçues", generate: "Générer le livre", preview: "Aperçu", order: "Commander l'impression", status: { collecting: "Collecte", generating: "Génération", ready: "Prêt", ordered: "Commandé", shipped: "Expédié" } },
      contributor: { name: "Nom", email: "Email", relationship: "Relation", invite: "Envoyer l'invitation", copyLink: "Copier le lien", linkCopied: "Lien copié!", pending: "En attente", contributed: "A contribué" },
      contribution: { title: "Partagez votre souvenir", welcome: "Bienvenue", forBook: "Vous contribuez au livre de", memoryTitle: "Titre du souvenir", memoryTitlePlaceholder: "Ejem: Cet été à la plage", memoryContent: "Votre histoire ou souvenir", memoryContentPlaceholder: "Racontez votre histoire en détail...", memoryDate: "Date approximative (optionnel)", emotion: "Comment décririez-vous ce souvenir?", emotions: { feliz: "Heureux", divertido: "Drôle", emotivo: "Émouvant", inspirador: "Inspirant" }, submit: "Envoyer le souvenir", thanks: "Merci pour votre contribution!", alreadyContributed: "Vous avez déjà envoyé votre contribution" },
      order: { checkout: "Finaliser la commande", summary: "Résumé de la commande", quantity: "Quantité", unitPrice: "Prix unitaire", shipping: "Livraison", total: "Total", shippingInfo: "Informations de livraison", fullName: "Nom complet", address: "Adresse", city: "Ville", postalCode: "Code postal", country: "Pays", phone: "Téléphone", payNow: "Payer maintenant", success: "Paiement effectué!", successDesc: "Votre commande est en cours de traitement", tracking: "Suivi", status: { pending: "En attente de paiement", paid: "Payé", processing: "En traitement", printing: "Impression", shipped: "Expédié", delivered: "Livré" } },
      admin: { title: "Panneau d'administration", subtitle: "Gérez les utilisateurs et supervisez la plateforme", refresh: "Actualiser", totalUsers: "Utilisateurs totaux", clients: "Clients", employees: "Employés", booksCreated: "Livres créés", totalOrders: "Commandes totales", newRecent: "Nouveaux (7 jours)", monthlyRevenue: "Revenus (mois)", clientManagement: "Gestion des clients", employeeManagement: "Gestion des employés", registeredUsers: "utilisateurs inscrits", registeredClients: "clients inscrits", registeredEmployees: "employés inscrits", searchPlaceholder: "Rechercher par nom, email ou téléphone...", user: "Utilisateur", contact: "Contact", books: "Livres", orders: "Commandes", role: "Rôle", registered: "Inscrit", actions: "Actions", viewDetails: "Voir les détails", makeAdmin: "Promouvoir admin", removeAdmin: "Retirer admin", deleteUser: "Supprimer", noUsersFound: "Aucun utilisateur trouvé", userDetails: "Détails de l'utilisateur", client: "Client", employee: "Employé", noBooks: "Aucun livre créé", noOrders: "Aucune commande", noEmployees: "Aucun employé enregistré", noEmployeesDesc: "Convertissez les clients en employés depuis l'onglet Clients", convertToEmployee: "Convertir en employé", convertToClient: "Convertir en client", convertedToEmployee: "Utilisateur converti en employé", convertedToClient: "Utilisateur converti en client", managePermissions: "Gérer les permissions", permissionsSaved: "Permissions mises à jour", perm_manage_users: "Gestion des utilisateurs", perm_manage_books: "Gestion des livres", perm_manage_orders: "Gestion des commandes", perm_manage_contributions: "Gestion des contributions", perm_view_stats: "Voir les statistiques", permDesc_manage_users: "Peut voir et gérer les comptes", permDesc_manage_books: "Peut voir et gérer les livres", permDesc_manage_orders: "Peut voir et gérer les commandes", permDesc_manage_contributions: "Peut voir et gérer les contributions", permDesc_view_stats: "Peut voir les statistiques de la plateforme", confirmDelete: "Supprimer l'utilisateur", confirmDeleteDesc: "Êtes-vous sûr de vouloir supprimer", deleteWarning: "Cette action supprimera définitivement:", deleteAccount: "Compte utilisateur", deleteAllBooks: "Tous ses livres", deleteAllOrders: "Toutes ses commandes", deleteContributions: "Toutes les contributions associées", cancel: "Annuler", userPromoted: "Utilisateur promu administrateur", adminRemoved: "Permissions d'admin retirées", userDeleted: "Utilisateur supprimé", bookDeleted: "Projet supprimé", editUser: "Modifier utilisateur", createUser: "Créer utilisateur", createClient: "Nouveau client", createEmployee: "Nouvel employé", userCreated: "Utilisateur créé avec succès", userUpdated: "Utilisateur mis à jour", fillRequired: "Remplissez les champs obligatoires", leaveBlankKeep: "laisser vide pour conserver", deleteBook: "Supprimer le projet", confirmDeleteBookDesc: "Voulez-vous vraiment supprimer ce projet", deleteBookWarning: "Cette action supprimera définitivement:", deleteBookData: "Le projet et tout son contenu", deleteBookContributors: "Tous les contributeurs assignés", deleteBookContributions: "Toutes les contributions reçues", deleteBookOrders: "Les commandes associées", accessDenied: "Accès refusé", noAdminPermissions: "Vous n'avez pas les permissions d'administrateur", noName: "Sans nom", bookStatusManagement: "Gestion des statuts des livres", totalBooks: "livres au total", searchBooks: "Rechercher par titre, propriétaire ou email...", owner: "Propriétaire", noBooksFound: "Aucun livre trouvé", statusUpdated: "Statut mis à jour avec succès", bookStatus: { alta: "Inscription", recopilando: "Collecte", generado: "Généré", generando: "Génération en cours", en_revision: "En révision", revisado: "Révisé", listo_impresion: "Prêt impression", enviado_imprenta: "Envoyé imprimeur", recibido_imprenta: "Reçu de l'imprimeur", recibido: "Reçu", revision_imprenta: "Révision impression", envio_prueba: "Envoi épreuve", ok_prueba: "Épreuve approuvée", envio_imprenta: "Envoi imprimeur", envio_cliente: "Envoi client", recibido_cliente: "Reçu client", regenerando: "Régénération", collecting: "Collecte", generating: "Génération", review: "En révision", reviewed: "Révisé", ready_print: "Prêt impression", sent_print: "Envoyé impression", sent_client: "Envoyé client", delivered: "Livré", ready: "Prêt", ordered: "Commandé" }, tracking: "Suivi", trackingOnTrack: "Dans les délais", trackingDelayed: "En retard", trackingCompleted: "Terminé", phaseConfig: "Configurer les délais", phaseConfigDesc: "Définir les délais standards (en jours) pour chaque phase", phaseConfigSaved: "Configuration des délais sauvegardée", phaseDetail: "Détail des phases", phaseTimeUpdated: "Délai de phase mis à jour", currentPhase: "Phase actuelle", viewPhases: "Voir les phases", days: "jours", defaultPhases: "Phases assignées par défaut", assignmentSaved: "Affectation sauvegardée", unassigned: "Non assigné", responsible: "Responsable", phase: "Phase", timing: "Délai", dueDate: "Échéance", pendingTasks: "Tâches en attente", taskAssignPhases: "Assigner les responsables", assignResponsibles: "Assigner", taskCompleted: "Tâche terminée", createdBy: "Créé par", phaseConfigApplied: "Délais appliqués à {{count}} livres", applyToAllBooks: "Appliquer à tous les livres" },
      createBook: { whoIsBookFor: "Pour qui est le livre?", selectProfile: "Sélectionnez le profil du destinataire", bookDetails: "Détails du livre", tellUsMore: "Dites-nous en plus sur le destinataire", customization: "Personnalisation", chooseLanguageStyle: "Choisissez la langue et le style du livre", step: "Étape", of: "de", summary: "Résumé", bookCreated: "Livre créé avec succès!", errorCreating: "Erreur lors de la création du livre", otherOccasion: "Précisez l'occasion", otherOccasionPlaceholder: "Ex: Hommage, Baptême, Communion..." },
      occasions: { cumpleanos: "Anniversaire", navidad: "Noël", jubilacion: "Retraite", aniversario: "Anniversaire de mariage", graduacion: "Remise de diplôme", dia_madre: "Fête des Mères", dia_padre: "Fête des Pères", otro: "Autre occasion" },
      coverStyles: { classic: "Classique", classicDesc: "Élégant et intemporel", modern: "Moderne", modernDesc: "Minimaliste et frais", playful: "Ludique", playfulDesc: "Coloré et joyeux", vintage: "Vintage", vintageDesc: "Nostalgique et chaleureux" },
      bookDetail: { backToDashboard: "Retour au tableau de bord", for: "Pour", collaborators: "Contributeurs", contributions: "Contributions", language: "Langue", created: "Créé", collaboratorList: "Liste des contributeurs", noCollaborators: "Pas encore de contributeurs", noCollaboratorsDesc: "Invitez famille et amis à partager leurs souvenirs", noContributions: "Pas encore de contributions", noContributionsDesc: "Les contributions apparaîtront ici quand les contributeurs enverront leurs souvenirs", addCollaboratorGuest: "Ajouter contributeur / invité", tableNumber: "N° de Table", selectTable: "Sélectionner table...", dietType: "Type de Régime", selectDiet: "Sélectionner régime...", openLink: "Ouvrir le lien", deleteCollaborator: "Supprimer contributeur", confirmDeleteDesc: "Êtes-vous sûr de vouloir supprimer", contributorAlreadyContributed: "Ce contributeur a déjà soumis sa contribution. Si vous le supprimez, sa contribution sera également supprimée.", completeRequired: "Complétez les champs requis", collaboratorAdded: "Contributeur ajouté", collaboratorDeleted: "Contributeur supprimé", needContribution: "Vous avez besoin d'au moins une contribution pour générer le livre", generating: "Génération...", bookGenerated: "Livre généré avec succès!", bookPreview: "Aperçu du livre", previewDesc: "Contenu généré par IA basé sur les contributions", by: "Par", confirmCollection: "Confirmer la fin de collecte", confirmCollectionDesc: "Confirmez-vous avoir reçu assez de contributions ? Le livre passera en phase de génération.", confirmCollectionBtn: "Confirmer et générer le livre", collectionConfirmed: "Collecte confirmée. Le livre passe en génération.", extendDeadline: "Prolonger le délai", extendDeadlineDesc: "Le délai standard de collecte est terminé. Vous pouvez prolonger le délai.", extendDays: "Jours supplémentaires", extendConfirm: "Prolonger le délai", deadlineExtended: "Délai prolongé avec succès", collectionDeadline: "Délai de collecte", collectionDeadlineExpired: "Le délai de collecte est expiré", daysRemaining: "jours restants", daysOverdue: "jours de retard" },
      orderTracking: { orderNotFound: "Commande non trouvée", backToPanel: "Retour au tableau de bord", order: "Commande", orderStatus: "Statut de la commande", inProgress: "En cours", trackingNumber: "Numéro de suivi", orderDetails: "Détails de la commande", copies: "exemplaires", copy: "exemplaire", shippingAddress: "Adresse de livraison", subtotal: "Sous-total", shippingCost: "Livraison", orderDate: "Commande passée", paymentSecure: "Paiement sécurisé avec" },
      common: { loading: "Chargement...", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", back: "Retour", next: "Suivant", previous: "Précédent", finish: "Terminer", select: "Sélectionner...", normal: "Normal", noName: "Sans nom" },
      coverEditor: { editorTitle: "Éditeur de modèle", coverName: "Nom de la couverture", uploadCoverImage: "Télécharger une image de couverture", backgroundType: "Type de fond", protagonistPhoto: "Photo du protagoniste", templateImage: "Image du modèle", photoFrame: "Cadre photo", hide: "Masquer", fullPhoto: "Photo plein fond", framedPhoto: "Photo encadrée", oval: "Ovale", circle: "Cercle", rectangle: "Rectangle", horizontalPos: "Pos. horizontale", verticalPos: "Pos. verticale", width: "Largeur", height: "Hauteur", rotation: "Rotation", coverBackground: "Fond de couverture", uploading: "Téléchargement...", changeBgImage: "Changer l'image de fond", uploadBgImage: "Télécharger image de fond", changeBgDesign: "Changer le design de fond", uploadCover: "Télécharger image de couverture", posHorizontal: "Position horizontale", posVertical: "Position verticale", fontSize: "Taille de police", color: "Couleur", typography: "Typographie", weight: "Épaisseur", transform: "Transformation", uppercase: "MAJUSCULES", capitalize: "Capitaliser", alignment: "Alignement", alignLeft: "Gauche", alignCenter: "Centre", alignRight: "Droite", templateSaved: "Modèle enregistré", saveError: "Erreur d'enregistrement", imageUpdated: "Image mise à jour", uploadError: "Erreur de téléchargement", frameAutoNote: "La photo du protagoniste sera placée automatiquement dans le cadre.", fieldProtagonistName: "Nom du protagoniste", fieldSubtitle: "Sous-titre", fieldTitle: "Titre du livre", fieldBranding: "Marque (A Gift of Memories)" },
      notifications: { loadingTemplates: "Chargement des modèles...", errorLoadingTemplates: "Erreur de chargement des modèles", errorLoadingLogs: "Erreur de chargement des logs", testEmailSent: "Email test envoyé à", testEmailError: "Erreur d'envoi de l'email test", templateUpdated: "Modèle mis à jour", templateCreated: "Modèle créé", saveError: "Erreur d'enregistrement", templateDeleted: "Modèle supprimé", deleteError: "Erreur de suppression", copiedToClipboard: "copié dans le presse-papiers", inactive: "Inactive", emailChannel: "Email", subject: "Objet", whatsappChannel: "WhatsApp", templatesTitle: "Modèles de notification", templatesDesc: "Gérez les emails et messages envoyés aux clients et contributeurs", templates: "Modèles", sendLogs: "Historique d'envois", newTemplate: "Nouveau modèle", clientNotifications: "Notifications client", noClientTemplates: "Aucun modèle client", collaboratorNotifications: "Notifications contributeur", noCollabTemplates: "Aucun modèle contributeur", loadingLogs: "Chargement des logs...", noLogs: "Aucun log d'envoi", colStatus: "Statut", colRecipient: "Destinataire", colSubjectEvent: "Objet / Événement", colType: "Type", colDate: "Date", test: "Test", real: "Réel", editTemplate: "Modifier le modèle", name: "Nom", templateName: "Nom du modèle", recipientType: "Destinataire", client: "Client", collaborator: "Contributeur", order: "Ordre", event: "Événement", active: "Active", availableVariables: "Variables disponibles (clic pour copier)", emailSubject: "Objet", emailSubjectPlaceholder: "Objet de l'email", body: "Corps", emailBodyPlaceholder: "Contenu de l'email.", message: "Message", whatsappPlaceholder: "Message WhatsApp.", saving: "Enregistrement...", sendTestEmail: "Envoyer email test", template: "Modèle", testEmailDesc: "Sera envoyé avec des données d'exemple.", emailRecipient: "Email destinataire", sending: "Envoi...", sendTest: "Envoyer test", deleteTemplate: "Supprimer le modèle", deleteWarning: "Cette action est irréversible.", sendTestTitle: "Envoyer email test" },
      formEditor: { shortText: "Texte court", longText: "Texte long", selector: "Sélecteur", options: "Options", scale: "Échelle", photos: "Images (max 2)", label: "Étiquette", type: "Type", placeholder: "Placeholder", helpText: "Texte d'aide...", required: "Obligatoire", optionLabel: "Étiquette", optionValue: "Valeur", addOption: "Option", min: "Min", max: "Max", sectionTitle: "Titre de section", description: "Description", repeatable: "Répétable", maxRepeat: "Max répétitions:", maxShort: "Max:", fields: "champs", repeatableTag: "Répétable", loadingForm: "Chargement du formulaire...", loadError: "Erreur de chargement", formLoadError: "Erreur de chargement du formulaire", customizeDesc: "Personnalisez les questions pour les contributeurs.", restore: "Restaurer", formSaved: "Formulaire enregistré", formSaveError: "Erreur d'enregistrement", formRestored: "Formulaire restauré", restoreError: "Erreur de restauration", newSection: "Nouvelle section", newField: "Nouveau champ", addField: "Ajouter champ", addSection: "Ajouter section" },
      bookDetailExtra: { pages: "Pages", generationError: "Erreur de génération", preparingBook: "Préparation de votre livre", generatingAI: "Génération du livre avec l'IA...", pagesGenerated: "Pages générées", bookTitle: "Titre du livre", coverDesign: "Design de couverture", selectCoverStyle: "Sélectionnez un style de couverture:", aBookFor: "Un livre pour", coverPreview: "Aperçu de la couverture", protagonistPhotoLabel: "Photo du protagoniste", adjustPhoto: "Ajuster la photo", zoom: "Zoom", saving: "Enregistrement...", sendReminder: "Rappel", reminderSent: "Rappel envoyé", reminderError: "Erreur d'envoi du rappel" },
      contributionExtra: { loadingForm: "Chargement du formulaire...", invalidLink: "Lien invalide", invalidLinkDesc: "Ce lien de contribution n'existe pas ou a expiré.", thanksTitle: "Merci pour votre contribution", contributeToBook: "Contribuer au livre de", step: "Étape", of: "de", needsMoreContent: "Votre contribution a besoin de plus de contenu", generatingExpanded: "Génération du contenu étendu...", expandingAI: "L'IA enrichit vos anecdotes.", expandedReady: "Contenu étendu prêt", editComfortably: "Modifiez le contenu confortablement", contentAccepted: "Contenu accepté" },
      adminExtra: { noAssignedTasks: "Vous n'avez pas de tâches assignées", noTeamTasks: "Pas de tâches d'équipe en attente", pagesCol: "Pages", estimatedDelivery: "Livraison estimée", templateRepo: "Dépôt de modèles", allProfiles: "Tous les profils", noTemplates: "Aucun modèle", unassigned: "Non assigné" },
      billing: { checkout: "Paiement", checkoutDesc: "Vérifiez votre commande et finalisez le paiement", orderSummary: "Résumé de la commande", personalizedBook: "Livre personnalisé", firstCopy: "Premier exemplaire", extraCopies: "exemplaires supplémentaires", extraCopy: "exemplaire supplémentaire", collaboratorShipping: "Expédition contributeurs", addresses: "adresses", subtotal: "Sous-total", discount: "Réduction", tax: "TVA", total: "Total", couponCode: "Code promo", couponPlaceholder: "Entrez votre code", applyCoupon: "Appliquer", couponApplied: "Code promo appliqué", couponInvalid: "Code invalide ou expiré", couponRemove: "Retirer", billingInfo: "Informations de facturation", billingInfoDesc: "Ces informations figureront sur votre facture", name: "Nom complet", company: "Entreprise (optionnel)", nif: "N° TVA", address: "Adresse", city: "Ville", postalCode: "Code postal", email: "Email de facturation", payAndCreate: "Payer et créer le livre", processing: "Traitement du paiement...", paymentSuccess: "Paiement effectué avec succès", paymentError: "Erreur de paiement", paymentSimulated: "Paiement simulé", confirmOrder: "Confirmer la commande", confirmOrderDesc: "Choisissez le nombre d'exemplaires avant l'envoi à l'impression", copies: "Nombre d'exemplaires", allowCollabPurchase: "Permettre aux contributeurs d'acheter le livre", allowCollabPurchaseDesc: "Les contributeurs pourront commander leur exemplaire pour 20€ + 5€ de livraison.", deliveryEstimate: "Livraison estimée: 15-20 jours", bookSpecs: "Broché · A5 · 200 pages", confirm: "Confirmer", invoices: "Factures", noInvoices: "Pas encore de factures", noInvoicesDesc: "Les factures seront générées automatiquement lors de vos commandes", invoiceNumber: "N° Facture", invoiceDate: "Date", invoiceType: "Type", invoiceTotal: "Total", invoiceStatus: "Statut", downloadPdf: "Télécharger PDF", typeInitial: "Livre", typeExtras: "Extras", statusPaid: "Payée", statusPending: "En attente", inclTax: "TVA incluse" }
    }
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        howItWorks: "So funktioniert's",
        pricing: "Preise",
        login: "Anmelden",
        register: "Registrieren",
        dashboard: "Dashboard",
        admin: "Admin",
        help: "Hilfe",
        logout: "Abmelden"
      },
      help: {
        title: "Hilfezentrum",
        subtitle: "Erhalten Sie Antworten vom Assistenten oder kontaktieren Sie uns direkt.",
        tabs: { chatbot: "KI-Assistent", faqs: "FAQ", tour: "Geführte Tour", contact: "Kontakt" },
        floating: { tooltip: "Hilfe" },
        tour: {
          title: "Geführte App-Tour",
          description: "Ein 60-Sekunden-Rundgang durch die wichtigsten Funktionen.",
          start: "Tour starten", restart: "Tour wiederholen", resetBtn: "Als nicht gesehen markieren",
          reset: "Tour zurückgesetzt. Erscheint beim nächsten Einloggen.",
          back: "Zurück", close: "Schließen", last: "Beenden", next: "Weiter", skip: "Überspringen",
          welcomeTitle: "Willkommen bei A Gift of Memories!",
          welcome: "Wir führen Sie in 60 Sekunden durch die App. Pfeile zum Weitergehen.",
          dashboard: "Dies ist Ihr Hauptdashboard. Sie sehen alle aktiven Bücher und deren Status.",
          createBook: "Hier klicken, um ein neues Buch zu erstellen. Wir führen Sie in 4 Schritten.",
          booksList: "Alle Ihre Bücher erscheinen hier. Klicken Sie, um zu verwalten.",
          invoices: "In diesem Tab finden Sie Ihre Rechnungen zum Download als PDF.",
          helpBtn: "Brauchen Sie Hilfe? Nutzen Sie diesen schwebenden Button jederzeit.",
          endTitle: "Fertig!",
          end: "Sie kennen die App. Für weitere Hilfe nutzen Sie den Chatbot oder die FAQ."
        },
        chatbot: { title: "Memories Assistent", subtitle: "Fragen Sie mich alles zur App", placeholder: "Schreiben Sie Ihre Frage...", voiceOn: "Stimme aktivieren", voiceOff: "Stimme aktiv", listen: "Anhören", stopListening: "Stopp" },
        chatError: "Antwort nicht möglich, bitte erneut versuchen.",
        faqs: {
          searchPlaceholder: "FAQ durchsuchen...",
          noResults: "Keine Ergebnisse",
          catAll: "Alle", catGeneral: "Allgemein", catStart: "Erste Schritte", catContributors: "Mitwirkende", catProcess: "Prozess", catAI: "Künstliche Intelligenz", catPricing: "Preise & Zahlung", catContent: "Buchinhalt", catPrivacy: "Datenschutz", catShipping: "Versand", catSupport: "Support"
        },
        contact: {
          categoryLabel: "Art der Anfrage",
          catQuestion: "Frage", catSuggestion: "Vorschlag", catIncident: "Vorfall", catComplaint: "Beschwerde",
          name: "Name", email: "E-Mail", subject: "Betreff", message: "Nachricht",
          privacy: "Ihre Daten werden nur zur Beantwortung Ihrer Anfrage verwendet.",
          submit: "Nachricht senden",
          sent: "Nachricht gesendet! Wir melden uns bald.",
          error: "Fehler beim Senden. Bitte erneut versuchen.",
          fillAll: "Bitte alle Felder ausfüllen",
          thanksTitle: "Nachricht erhalten!",
          thanksDesc: "Wir haben eine Bestätigungs-E-Mail gesendet. Antwort innerhalb 24 Geschäftsstunden.",
          sendAnother: "Weitere Nachricht senden"
        }
      },
      hero: {
        title: "Erstellen Sie ein einzigartiges Buch voller Erinnerungen",
        subtitle: "Sammeln Sie Geschichten von Familie und Freunden, und unsere KI verwandelt sie in ein wunderschönes personalisiertes Buch",
        cta: "Mein Buch erstellen"
      },
      profiles: {
        title: "Für alle Altersgruppen",
        subtitle: "Personalisierte Bücher für jede Lebensphase",
        child: "Kinder",
        childDesc: "Magische Geschichten für die Kleinen",
        teen: "Jugendliche",
        teenDesc: "Lustige und bedeutsame Erinnerungen",
        adult: "Erwachsene",
        adultDesc: "Tiefe und emotionale Reflexionen",
        senior: "Senioren",
        seniorDesc: "Ein ganzes Leben feiern",
        infantil: "Kinder",
        adolescente: "Jugendliche",
        adulto: "Erwachsene",
        tercera_edad: "Senioren",
        terceraedad: "Senioren"
      },
      howItWorks: {
        title: "Wie funktioniert es?",
        subtitle: "In 4 einfachen Schritten haben Sie ein unvergessliches Geschenk",
        step1: { title: "Erstellen Sie Ihr Projekt", desc: "Wählen Sie das Profil des Empfängers und den besonderen Anlass" },
        step2: { title: "Laden Sie Mitwirkende ein", desc: "Familie und Freunde teilen ihre Erinnerungen" },
        step3: { title: "Wir erstellen ein einzigartiges Stück", desc: "Wir helfen Ihnen, das Buch mit unseren KI-Agenten zu schreiben" },
        step4: { title: "Erhalten Sie Ihr Buch", desc: "Premium gedruckt und zu Ihnen geliefert" }
      },
      pricing: {
        title: "Transparente Preise",
        subtitle: "Keine Überraschungen, keine versteckten Kosten",
        basePrice: "60€", basePriceLabel: "erstes Exemplar",
        extraPrice: "+20€", extraPriceLabel: "pro zusätzliches Exemplar",
        shippingCollaborators: "+5€ pro Adresse (wenn Mitwirkende kaufen)",
        deliveryTime: "Lieferung in 15-20 Tagen",
        features: { pages: "200 Seiten (schwarz/weiß und Farbe)", format: "Softcover, A5-Format", contributors: "Unbegrenzte Mitwirkende", ai: "Personalisierte KI-Generierung", cover: "Individuelles Cover, Rücken und Rückseite", reviews: "KI-generierte humorvolle Rezensionen", extras: "Zusätzliche Exemplare für Familie und Freunde" },
        collaboratorsNote: "Mitwirkende können auch ihr eigenes Exemplar kaufen (+20€ + 5€ Versand)",
        cta: "Jetzt starten"
      },
      footer: { tagline: "Erinnerungen schaffen, die bleiben", rights: "Alle Rechte vorbehalten" },
      auth: { login: "Anmelden", register: "Konto erstellen", email: "E-Mail", password: "Passwort", name: "Vollständiger Name", firstName: "Vorname", lastName: "Nachname", phone: "Telefon", forgotPassword: "Passwort vergessen?", rememberMe: "Angemeldet bleiben", noAccount: "Kein Konto?", hasAccount: "Bereits ein Konto?", orContinueWith: "Oder fortfahren mit", google: "Mit Google fortfahren", resetPassword: "Passwort zurücksetzen", resetDescription: "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen", sendResetLink: "Link senden", resetSent: "Link gesendet", resetSentDesc: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie einen Link zum Zurücksetzen", resetLinkPreview: "Link zum Zurücksetzen:", clickToReset: "Klicken Sie hier, um Ihr Passwort zurückzusetzen", backToLogin: "Zurück zur Anmeldung", newPassword: "Neues Passwort", confirmPassword: "Passwort bestätigen", changePassword: "Passwort ändern", passwordMismatch: "Passwörter stimmen nicht überein", passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein", passwordResetSuccess: "Passwort erfolgreich geändert. Melden Sie sich mit Ihrem neuen Passwort an", resetError: "Fehler beim Zurücksetzen des Passworts", invalidToken: "Ungültiger Link", invalidTokenDesc: "Dieser Link ist abgelaufen oder ungültig. Fordern Sie einen neuen an.", requestNewLink: "Neuen Link anfordern" },
      dashboard: { welcome: "Willkommen", myBooks: "Meine Bücher", createNew: "Neues Buch erstellen", noBooks: "Noch keine Bücher", noBooksDesc: "Erstellen Sie Ihr erstes personalisiertes Buch", orders: "Meine Bestellungen", noOrders: "Noch keine Bestellungen", noOrdersDesc: "Wenn Sie ein Buch bestellen, erscheint es hier", book: "Buch", books: "Bücher", filterAll: "Alle", filterActive: "Aktiv", filterClosed: "Abgeschlossen", noFilteredBooks: "Keine Bücher mit diesem Filter", colTitle: "Titel", colRecipient: "Empfänger", colStatus: "Status", colDate: "Datum", deleteBook: "Buch löschen", confirmDeleteBook: "Möchten Sie dieses Buch wirklich löschen", deleteBookWarning: "Diese Aktion löscht dauerhaft:", deleteBookData: "Das Buch und alle generierten Inhalte", deleteBookContributors: "Alle zugewiesenen Mitwirkenden", deleteBookContributions: "Alle erhaltenen Beiträge", bookDeleted: "Buch erfolgreich gelöscht", myTasks: "Meine ausstehenden Aufgaben", delayed: "Verspätet", remaining: "verbleibend", onTrack: "Im Zeitplan", pendingTasks: "ausstehende Aufgaben", noTasksDesc: "Sie haben keine ausstehenden Aufgaben", changePhase: "Phase ändern", selectPhase: "Phase auswählen", statusChanged: "Status erfolgreich geändert" },
      book: { create: "Buch erstellen", title: "Buchtitel", titlePlaceholder: "Ejem: Marias Buch", profile: "Empfängerprofil", recipientName: "Name des Empfängers", recipientAge: "Alter (optional)", relationship: "Ihre Beziehung zum Empfänger", occasion: "Besonderer Anlass", language: "Buchsprache", coverStyle: "Cover-Stil", contributors: "Mitwirkende", addContributor: "Mitwirkenden hinzufügen", contributions: "Erhaltene Beiträge", generate: "Buch generieren", preview: "Vorschau", order: "Druck bestellen", status: { collecting: "Sammeln", generating: "Generieren", ready: "Bereit", ordered: "Bestellt", shipped: "Versendet" } },
      contributor: { name: "Name", email: "E-Mail", relationship: "Beziehung", invite: "Einladung senden", copyLink: "Link kopieren", linkCopied: "Link kopiert!", pending: "Ausstehend", contributed: "Beigetragen" },
      contribution: { title: "Teilen Sie Ihre Erinnerung", welcome: "Willkommen", forBook: "Sie tragen zum Buch von", memoryTitle: "Titel der Erinnerung", memoryTitlePlaceholder: "Ejem: Dieser Sommer am Strand", memoryContent: "Ihre Geschichte oder Erinnerung", memoryContentPlaceholder: "Erzählen Sie Ihre Geschichte ausführlich...", memoryDate: "Ungefähres Datum (optional)", emotion: "Wie würden Sie diese Erinnerung beschreiben?", emotions: { feliz: "Glücklich", divertido: "Lustig", emotivo: "Emotional", inspirador: "Inspirierend" }, submit: "Erinnerung senden", thanks: "Danke für Ihren Beitrag!", alreadyContributed: "Sie haben bereits Ihren Beitrag gesendet" },
      order: { checkout: "Zur Kasse", summary: "Bestellübersicht", quantity: "Menge", unitPrice: "Stückpreis", shipping: "Versand", total: "Gesamt", shippingInfo: "Lieferinformationen", fullName: "Vollständiger Name", address: "Adresse", city: "Stadt", postalCode: "Postleitzahl", country: "Land", phone: "Telefon", payNow: "Jetzt bezahlen", success: "Zahlung abgeschlossen!", successDesc: "Ihre Bestellung wird bearbeitet", tracking: "Sendungsverfolgung", status: { pending: "Zahlung ausstehend", paid: "Bezahlt", processing: "In Bearbeitung", printing: "Wird gedruckt", shipped: "Versendet", delivered: "Zugestellt" } },
      admin: { title: "Administrationsbereich", subtitle: "Benutzer verwalten und Plattform überwachen", refresh: "Aktualisieren", totalUsers: "Benutzer gesamt", clients: "Kunden", employees: "Mitarbeiter", booksCreated: "Bücher erstellt", totalOrders: "Bestellungen gesamt", newRecent: "Neu (7 Tage)", monthlyRevenue: "Einnahmen (Monat)", clientManagement: "Kundenverwaltung", employeeManagement: "Mitarbeiterverwaltung", registeredUsers: "registrierte Benutzer", registeredClients: "registrierte Kunden", registeredEmployees: "registrierte Mitarbeiter", searchPlaceholder: "Nach Name, E-Mail oder Telefon suchen...", user: "Benutzer", contact: "Kontakt", books: "Bücher", orders: "Bestellungen", role: "Rolle", registered: "Registriert", actions: "Aktionen", viewDetails: "Details anzeigen", makeAdmin: "Zum Admin machen", removeAdmin: "Admin entfernen", deleteUser: "Löschen", noUsersFound: "Keine Benutzer gefunden", userDetails: "Benutzerdetails", client: "Kunde", employee: "Mitarbeiter", noBooks: "Keine Bücher erstellt", noOrders: "Keine Bestellungen", noEmployees: "Keine registrierten Mitarbeiter", noEmployeesDesc: "Konvertieren Sie Kunden zu Mitarbeitern über den Kunden-Tab", convertToEmployee: "Zum Mitarbeiter machen", convertToClient: "Zum Kunden machen", convertedToEmployee: "Benutzer als Mitarbeiter konvertiert", convertedToClient: "Benutzer als Kunde konvertiert", managePermissions: "Berechtigungen verwalten", permissionsSaved: "Berechtigungen aktualisiert", perm_manage_users: "Benutzerverwaltung", perm_manage_books: "Bücherverwaltung", perm_manage_orders: "Bestellverwaltung", perm_manage_contributions: "Beitragsverwaltung", perm_view_stats: "Statistiken anzeigen", permDesc_manage_users: "Kann Benutzerkonten sehen und verwalten", permDesc_manage_books: "Kann alle Bücher sehen und verwalten", permDesc_manage_orders: "Kann Bestellungen sehen und verwalten", permDesc_manage_contributions: "Kann Beiträge sehen und verwalten", permDesc_view_stats: "Kann Plattformstatistiken sehen", confirmDelete: "Benutzer löschen", confirmDeleteDesc: "Sind Sie sicher, dass Sie löschen möchten", deleteWarning: "Diese Aktion löscht dauerhaft:", deleteAccount: "Benutzerkonto", deleteAllBooks: "Alle Bücher", deleteAllOrders: "Alle Bestellungen", deleteContributions: "Alle zugehörigen Beiträge", cancel: "Abbrechen", userPromoted: "Benutzer zum Admin befördert", adminRemoved: "Admin-Berechtigungen entfernt", userDeleted: "Benutzer gelöscht", bookDeleted: "Projekt gelöscht", editUser: "Benutzer bearbeiten", createUser: "Benutzer erstellen", createClient: "Neuer Kunde", createEmployee: "Neuer Mitarbeiter", userCreated: "Benutzer erfolgreich erstellt", userUpdated: "Benutzer aktualisiert", fillRequired: "Pflichtfelder ausfüllen", leaveBlankKeep: "leer lassen um beizubehalten", deleteBook: "Projekt löschen", confirmDeleteBookDesc: "Möchten Sie dieses Projekt wirklich löschen", deleteBookWarning: "Diese Aktion löscht dauerhaft:", deleteBookData: "Das Projekt und seinen gesamten Inhalt", deleteBookContributors: "Alle zugewiesenen Mitwirkenden", deleteBookContributions: "Alle erhaltenen Beiträge", deleteBookOrders: "Zugehörige Bestellungen", accessDenied: "Zugriff verweigert", noAdminPermissions: "Sie haben keine Admin-Berechtigungen", noName: "Kein Name", bookStatusManagement: "Buchstatus-Verwaltung", totalBooks: "Bücher insgesamt", searchBooks: "Nach Titel, Besitzer oder E-Mail suchen...", owner: "Besitzer", noBooksFound: "Keine Bücher gefunden", statusUpdated: "Status erfolgreich aktualisiert", bookStatus: { alta: "Registrierung", recopilando: "Sammeln", generado: "Generiert", generando: "Wird generiert", en_revision: "In Prüfung", revisado: "Geprüft", listo_impresion: "Druckbereit", enviado_imprenta: "An Druckerei gesendet", recibido_imprenta: "Von Druckerei erhalten", recibido: "Empfangen", revision_imprenta: "Druckprüfung", envio_prueba: "Probedruck gesendet", ok_prueba: "Probedruck genehmigt", envio_imprenta: "An Druckerei gesendet", envio_cliente: "An Kunde gesendet", recibido_cliente: "Vom Kunden erhalten", regenerando: "Regenerierung", collecting: "Sammeln", generating: "Generieren", review: "In Prüfung", reviewed: "Geprüft", ready_print: "Druckbereit", sent_print: "Zum Druck gesendet", sent_client: "An Kunde gesendet", delivered: "Zugestellt", ready: "Bereit", ordered: "Bestellt" }, tracking: "Verfolgung", trackingOnTrack: "Im Zeitplan", trackingDelayed: "Verspätet", trackingCompleted: "Abgeschlossen", phaseConfig: "Zeiten konfigurieren", phaseConfigDesc: "Standardzeiten (in Tagen) für jede Buchphase festlegen", phaseConfigSaved: "Zeitenkonfiguration gespeichert", phaseDetail: "Phasendetail", phaseTimeUpdated: "Phasenzeit aktualisiert", currentPhase: "Aktuelle Phase", viewPhases: "Phasen anzeigen", days: "Tage", defaultPhases: "Standard zugewiesene Phasen", assignmentSaved: "Zuweisung gespeichert", unassigned: "Nicht zugewiesen", responsible: "Verantwortlich", phase: "Phase", timing: "Zeitplan", dueDate: "Fälligkeitsdatum", pendingTasks: "Ausstehende Aufgaben", taskAssignPhases: "Verantwortliche zuweisen", assignResponsibles: "Zuweisen", taskCompleted: "Aufgabe abgeschlossen", createdBy: "Erstellt von", phaseConfigApplied: "Zeiten auf {{count}} Bücher angewendet", applyToAllBooks: "Auf alle Bücher anwenden" },
      createBook: { whoIsBookFor: "Für wen ist das Buch?", selectProfile: "Wählen Sie das Profil des Empfängers", bookDetails: "Buchdetails", tellUsMore: "Erzählen Sie uns mehr über den Empfänger", customization: "Anpassung", chooseLanguageStyle: "Wählen Sie Sprache und Stil des Buches", step: "Schritt", of: "von", summary: "Zusammenfassung", bookCreated: "Buch erfolgreich erstellt!", errorCreating: "Fehler beim Erstellen des Buches", otherOccasion: "Anlass angeben", otherOccasionPlaceholder: "Z.B.: Ehrung, Taufe, Kommunion..." },
      occasions: { cumpleanos: "Geburtstag", navidad: "Weihnachten", jubilacion: "Ruhestand", aniversario: "Jubiläum", graduacion: "Abschlussfeier", dia_madre: "Muttertag", dia_padre: "Vatertag", otro: "Anderer Anlass" },
      coverStyles: { classic: "Klassisch", classicDesc: "Elegant und zeitlos", modern: "Modern", modernDesc: "Minimalistisch und frisch", playful: "Verspielt", playfulDesc: "Farbenfroh und fröhlich", vintage: "Vintage", vintageDesc: "Nostalgisch und warm" },
      bookDetail: { backToDashboard: "Zurück zum Dashboard", for: "Für", collaborators: "Mitwirkende", contributions: "Beiträge", language: "Sprache", created: "Erstellt", collaboratorList: "Mitwirkendenliste", noCollaborators: "Noch keine Mitwirkenden", noCollaboratorsDesc: "Laden Sie Familie und Freunde ein, ihre Erinnerungen zu teilen", noContributions: "Noch keine Beiträge", noContributionsDesc: "Beiträge werden hier angezeigt, wenn Mitwirkende ihre Erinnerungen senden", addCollaboratorGuest: "Mitwirkenden / Gast hinzufügen", tableNumber: "Tisch-Nr.", selectTable: "Tisch auswählen...", dietType: "Ernährungstyp", selectDiet: "Ernährung auswählen...", openLink: "Link öffnen", deleteCollaborator: "Mitwirkenden löschen", confirmDeleteDesc: "Sind Sie sicher, dass Sie löschen möchten", contributorAlreadyContributed: "Dieser Mitwirkende hat bereits seinen Beitrag eingereicht. Wenn Sie ihn löschen, wird auch sein Beitrag entfernt.", completeRequired: "Füllen Sie die Pflichtfelder aus", collaboratorAdded: "Mitwirkender hinzugefügt", collaboratorDeleted: "Mitwirkender gelöscht", needContribution: "Sie benötigen mindestens einen Beitrag, um das Buch zu generieren", generating: "Wird generiert...", bookGenerated: "Buch erfolgreich generiert!", bookPreview: "Buchvorschau", previewDesc: "KI-generierter Inhalt basierend auf Beiträgen", by: "Von", confirmCollection: "Sammlung abschließen bestätigen", confirmCollectionDesc: "Bestätigen Sie, dass Sie genügend Beiträge erhalten haben? Das Buch wird zur Generierung übergehen.", confirmCollectionBtn: "Bestätigen und Buch generieren", collectionConfirmed: "Sammlung bestätigt. Buch geht zur Generierung.", extendDeadline: "Frist verlängern", extendDeadlineDesc: "Die Standardsammelzeit ist abgelaufen. Sie können die Frist verlängern.", extendDays: "Zusätzliche Tage", extendConfirm: "Frist verlängern", deadlineExtended: "Frist erfolgreich verlängert", collectionDeadline: "Sammelfrist", collectionDeadlineExpired: "Sammelfrist ist abgelaufen", daysRemaining: "Tage verbleibend", daysOverdue: "Tage überfällig" },
      orderTracking: { orderNotFound: "Bestellung nicht gefunden", backToPanel: "Zurück zum Dashboard", order: "Bestellung", orderStatus: "Bestellstatus", inProgress: "In Bearbeitung", trackingNumber: "Sendungsnummer", orderDetails: "Bestelldetails", copies: "Exemplare", copy: "Exemplar", shippingAddress: "Lieferadresse", subtotal: "Zwischensumme", shippingCost: "Versand", orderDate: "Bestellung aufgegeben", paymentSecure: "Sichere Zahlung mit" },
      common: { loading: "Laden...", save: "Speichern", cancel: "Abbrechen", delete: "Löschen", edit: "Bearbeiten", back: "Zurück", next: "Weiter", previous: "Zurück", finish: "Fertig", select: "Auswählen...", normal: "Normal", noName: "Kein Name" },
      coverEditor: { editorTitle: "Vorlagen-Editor", coverName: "Cover-Name", uploadCoverImage: "Cover-Bild hochladen", backgroundType: "Hintergrundtyp", protagonistPhoto: "Protagonistenfoto", templateImage: "Vorlagenbild", photoFrame: "Fotorahmen", hide: "Ausblenden", fullPhoto: "Foto als Hintergrund", framedPhoto: "Gerahmtes Foto", oval: "Oval", circle: "Kreis", rectangle: "Rechteck", horizontalPos: "Hor. Position", verticalPos: "Vert. Position", width: "Breite", height: "Höhe", rotation: "Drehung", coverBackground: "Cover-Hintergrund", uploading: "Hochladen...", changeBgImage: "Hintergrundbild ändern", uploadBgImage: "Hintergrundbild hochladen", changeBgDesign: "Hintergrunddesign ändern", uploadCover: "Cover-Bild hochladen", posHorizontal: "Horizontale Position", posVertical: "Vertikale Position", fontSize: "Schriftgröße", color: "Farbe", typography: "Typografie", weight: "Stärke", transform: "Transformation", uppercase: "GROSSBUCHSTABEN", capitalize: "Großschreiben", alignment: "Ausrichtung", alignLeft: "Links", alignCenter: "Mitte", alignRight: "Rechts", templateSaved: "Vorlage gespeichert", saveError: "Fehler beim Speichern", imageUpdated: "Bild aktualisiert", uploadError: "Fehler beim Hochladen", frameAutoNote: "Das Protagonistenfoto wird automatisch im Rahmen platziert.", fieldProtagonistName: "Name des Protagonisten", fieldSubtitle: "Untertitel", fieldTitle: "Buchtitel", fieldBranding: "Marke (A Gift of Memories)" },
      notifications: { loadingTemplates: "Vorlagen laden...", errorLoadingTemplates: "Fehler beim Laden der Vorlagen", errorLoadingLogs: "Fehler beim Laden der Logs", testEmailSent: "Test-E-Mail gesendet an", testEmailError: "Fehler beim Senden der Test-E-Mail", templateUpdated: "Vorlage aktualisiert", templateCreated: "Vorlage erstellt", saveError: "Fehler beim Speichern", templateDeleted: "Vorlage gelöscht", deleteError: "Fehler beim Löschen", copiedToClipboard: "in Zwischenablage kopiert", inactive: "Inaktiv", emailChannel: "E-Mail", subject: "Betreff", whatsappChannel: "WhatsApp", templatesTitle: "Benachrichtigungsvorlagen", templatesDesc: "E-Mails und Nachrichten an Kunden und Mitwirkende verwalten", templates: "Vorlagen", sendLogs: "Sendeprotokoll", newTemplate: "Neue Vorlage", clientNotifications: "Kundenbenachrichtigungen", noClientTemplates: "Keine Kundenvorlagen", collaboratorNotifications: "Mitwirkende-Benachrichtigungen", noCollabTemplates: "Keine Mitwirkende-Vorlagen", loadingLogs: "Protokolle laden...", noLogs: "Keine Sendeprotokolle", colStatus: "Status", colRecipient: "Empfänger", colSubjectEvent: "Betreff / Ereignis", colType: "Typ", colDate: "Datum", test: "Test", real: "Echt", editTemplate: "Vorlage bearbeiten", name: "Name", templateName: "Vorlagenname", recipientType: "Empfänger", client: "Kunde", collaborator: "Mitwirkender", order: "Reihenfolge", event: "Ereignis", active: "Aktiv", availableVariables: "Verfügbare Variablen (klicken zum Kopieren)", emailSubject: "Betreff", emailSubjectPlaceholder: "E-Mail-Betreff", body: "Text", emailBodyPlaceholder: "E-Mail-Inhalt.", message: "Nachricht", whatsappPlaceholder: "WhatsApp-Nachricht.", saving: "Speichern...", sendTestEmail: "Test-E-Mail senden", template: "Vorlage", testEmailDesc: "Wird mit Beispieldaten gesendet.", emailRecipient: "Empfänger-E-Mail", sending: "Senden...", sendTest: "Test senden", deleteTemplate: "Vorlage löschen", deleteWarning: "Diese Aktion kann nicht rückgängig gemacht werden.", sendTestTitle: "Test-E-Mail senden" },
      formEditor: { shortText: "Kurztext", longText: "Langtext", selector: "Auswahl", options: "Optionen", scale: "Skala", photos: "Bilder (max 2)", label: "Bezeichnung", type: "Typ", placeholder: "Platzhalter", helpText: "Hilfetext...", required: "Pflichtfeld", optionLabel: "Bezeichnung", optionValue: "Wert", addOption: "Option", min: "Min", max: "Max", sectionTitle: "Abschnittstitel", description: "Beschreibung", repeatable: "Wiederholbar", maxRepeat: "Max Wiederholungen:", maxShort: "Max:", fields: "Felder", repeatableTag: "Wiederholbar", loadingForm: "Formular laden...", loadError: "Ladefehler", formLoadError: "Fehler beim Laden des Formulars", customizeDesc: "Passen Sie die Fragen für Mitwirkende an.", restore: "Wiederherstellen", formSaved: "Formular gespeichert", formSaveError: "Fehler beim Speichern", formRestored: "Formular wiederhergestellt", restoreError: "Fehler beim Wiederherstellen", newSection: "Neuer Abschnitt", newField: "Neues Feld", addField: "Feld hinzufügen", addSection: "Abschnitt hinzufügen" },
      bookDetailExtra: { pages: "Seiten", generationError: "Generierungsfehler", preparingBook: "Ihr Buch wird vorbereitet", generatingAI: "Buch wird mit KI generiert...", pagesGenerated: "Generierte Seiten", bookTitle: "Buchtitel", coverDesign: "Cover-Design", selectCoverStyle: "Wählen Sie einen Cover-Stil:", aBookFor: "Ein Buch für", coverPreview: "Cover-Vorschau", protagonistPhotoLabel: "Protagonistenfoto", adjustPhoto: "Foto anpassen", zoom: "Zoom", saving: "Speichern...", sendReminder: "Erinnerung", reminderSent: "Erinnerung gesendet", reminderError: "Fehler beim Senden der Erinnerung" },
      contributionExtra: { loadingForm: "Formular laden...", invalidLink: "Ungültiger Link", invalidLinkDesc: "Dieser Beitragslink existiert nicht oder ist abgelaufen.", thanksTitle: "Danke für Ihren Beitrag", contributeToBook: "Beitrag zum Buch von", step: "Schritt", of: "von", needsMoreContent: "Ihr Beitrag braucht mehr Inhalt", generatingExpanded: "Erweiterter Inhalt wird generiert...", expandingAI: "KI bereichert Ihre Geschichten.", expandedReady: "Erweiterter Inhalt bereit", editComfortably: "Bearbeiten Sie den Inhalt bequem", contentAccepted: "Inhalt akzeptiert" },
      adminExtra: { noAssignedTasks: "Keine zugewiesenen Aufgaben", noTeamTasks: "Keine ausstehenden Teamaufgaben", pagesCol: "Seiten", estimatedDelivery: "Geschätzte Lieferung", templateRepo: "Vorlagen-Repository", allProfiles: "Alle Profile", noTemplates: "Keine Vorlagen", unassigned: "Nicht zugewiesen" },
      billing: { checkout: "Bezahlung", checkoutDesc: "Überprüfen Sie Ihre Bestellung und schließen Sie die Zahlung ab", orderSummary: "Bestellübersicht", personalizedBook: "Personalisiertes Buch", firstCopy: "Erstes Exemplar", extraCopies: "zusätzliche Exemplare", extraCopy: "zusätzliches Exemplar", collaboratorShipping: "Mitwirkende-Versand", addresses: "Adressen", subtotal: "Zwischensumme", discount: "Rabatt", tax: "MwSt.", total: "Gesamt", couponCode: "Gutscheincode", couponPlaceholder: "Code eingeben", applyCoupon: "Einlösen", couponApplied: "Gutschein eingelöst", couponInvalid: "Ungültiger oder abgelaufener Gutschein", couponRemove: "Entfernen", billingInfo: "Rechnungsdaten", billingInfoDesc: "Diese Daten erscheinen auf Ihrer Rechnung", name: "Vollständiger Name", company: "Unternehmen (optional)", nif: "Steuer-ID", address: "Adresse", city: "Stadt", postalCode: "Postleitzahl", email: "Rechnungs-E-Mail", payAndCreate: "Bezahlen und Buch erstellen", processing: "Zahlung wird verarbeitet...", paymentSuccess: "Zahlung erfolgreich", paymentError: "Zahlungsfehler", paymentSimulated: "Simulierte Zahlung", confirmOrder: "Bestellung bestätigen", confirmOrderDesc: "Wählen Sie die Anzahl der Exemplare vor dem Druck", copies: "Anzahl der Exemplare", allowCollabPurchase: "Mitwirkenden den Kauf erlauben", allowCollabPurchaseDesc: "Mitwirkende können ihr eigenes Exemplar für 20€ + 5€ Versand bestellen.", deliveryEstimate: "Geschätzte Lieferung: 15-20 Tage", bookSpecs: "Taschenbuch · A5 · 200 Seiten", confirm: "Bestätigen", invoices: "Rechnungen", noInvoices: "Noch keine Rechnungen", noInvoicesDesc: "Rechnungen werden automatisch bei Bestellungen erstellt", invoiceNumber: "Rechnungs-Nr.", invoiceDate: "Datum", invoiceType: "Typ", invoiceTotal: "Gesamt", invoiceStatus: "Status", downloadPdf: "PDF herunterladen", typeInitial: "Buch", typeExtras: "Extras", statusPaid: "Bezahlt", statusPending: "Ausstehend", inclTax: "MwSt. enthalten" }
    }
  }
};

const savedLang = typeof window !== 'undefined' ? localStorage.getItem('i18n_lang') : null;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18n_lang', lng);
});

export default i18n;
